<div class="h1 content-title text-center p-3">Pályázatok</div>

<div class="content col-lg-10 mx-auto">
  <app-accordion title="Versenyképes Járások pályázat">
    <div class="p-3">
      <div class="row">
        <div class="col-12">
          Dunaszentmiklós Község Önkormányzata a 2025. évben a
          Területfejlesztési Alapba a Versenyképes Járások Programból kapott
          támogatást meghaladó összegű befizetést teljesített. Ezért
          Magyarország Koránya – a közigazgatási és területfejlesztési
          miniszter, mint támogató útján – a Területfejlesztési Alapba történő
          befizetése 5 076 333.- forint összegű részét számára támogatásként
          visszatérítette.
          <br />
          <br />

          Dunaszentmiklós Község Önkormányzata a 2025. évben a
          Területfejlesztési Alapba a Versenyképes Járások Programból kapott
          támogatást meghaladó összegű befizetést teljesített. Ezért
          Magyarország Kormánya – a közigazgatási és területfejlesztési
          miniszter, mint támogató útján - a Területfejlesztési Alapba történő
          befizetése 7 000 000.- forint összegű részét számára támogatásként
          visszatérítette. 2026.március 31.
        </div>
      </div>
    </div>
  </app-accordion>

  <app-accordion
    title="VP6-7.2.1.1-21 - Külterületi közutak fejlesztése Dunaszentmiklós Községben"
  >
    <div class="p-3">
      <div class="row">
        <div class="col-12">
          <strong>Kedvezményezett neve:</strong>&nbsp;&nbsp;Dunaszentmiklós
          Község Önkormányzata<br />

          <strong>Projekt címe:</strong>&nbsp;&nbsp;&nbsp;Külterületi közutak
          fejlesztése Dunaszentmiklós Községben<br />

          <strong>Projekt azonosítószáma:</strong>&nbsp;VP6-7.2.1.1-215<br />

          <strong>A támogatás összege</strong>: 146 562 022 Ftt<br />

          <strong>Támogatás mértéke:</strong>&nbsp;95%<br /><br />

          Külterületi közutak fejlesztése Dunaszentmiklós Községben című,
          VP6-7.2.1.1-21 kódszámú projekt Dunaszentmiklós Község Önkormányzata a
          3348127323 azonosító számú projekt keretében összesen 5 db külterületi
          út korszerűsítését, 2874,8 méter hosszúságban valósította meg. A
          felújított útszakaszok az alábbiak:
          <ul>
            <li>Dunaszentmiklós 092/29 hrsz terület</li>
            <li>Dunaszentmiklós 088/2 hrsz terület</li>
            <li>Dunaszentmiklós 033/18 hrsz terület</li>
            <li>Dunaszentmiklós Faház utca</li>
            <li>Dunaszentmiklós 055 hrsz. út, az Északi és a Felső út</li>
          </ul>
          <br /><br />
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20230830_160227.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20230830_160314.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20231111_135724.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20231111_135748.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20231124_145105.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20231124_145157.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20231215_143835.jpg"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20230827_114900.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20240421_114821.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20240401_101936.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20240326_155636.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20230827_114853.jpg"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20230927_170941.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20230927_171027.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20231112_111048.jpg"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20231112_110739.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20231112_110824.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20231112_111043.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20231214_153351.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20231221_100713.jpg"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20230927_172411.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20230927_172459.jpg"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2024/09/IMG_20230927_172548.jpg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-accordion>

  <app-accordion
    title="TOP_PLUSZ-1.2.1-21-KO1-2022-00015 - Csapadékvíz elvezetés fejlesztése Petőfi – Kenderkert utca mentén"
  >
    <div class="p-3">
      <div class="row">
        <div class="col-12">
          <strong>Kedvezményezett neve:</strong>&nbsp;&nbsp;Dunaszentmiklós
          Község Önkormányzata<br />

          <strong>Projekt címe:</strong>&nbsp;&nbsp;&nbsp;Csapadékvíz elvezetés
          fejlesztése Petőfi – Kenderkert utca mentén<br />

          <strong>Projekt azonosítószáma:</strong
          >&nbsp;TOP_PLUSZ-1.2.1-21-KO1-2022-00015<br />

          <strong>A támogatás összege</strong>: 50 000 059 Ft<br />

          <strong>Támogatás mértéke:</strong>&nbsp;100%<br /><br />
          <strong>A projekt tervezett befejezési dátuma:</strong
          >&nbsp;2025.12.31<br /><br />

          A projekt célja Dunaszentmiklós településen a tervezési területre
          lehulló csapadékvíz biztonságos bevezetése a befogadóba, átlagos
          esőzések idején a területen élők komfortérzetének javítása, nagyobb
          esőzésekor a belterület és az ingatlanok megóvása a vízkártól.<br /><br />
          Tervezett műszaki megoldások:<br />
          A Petőfi utcában 36 fm hosszon vb. mederelemes burkolt árok épül, a
          kapubehajtók vonalában vb. fedlappal lefedve. Az árok végétől a
          Kenderkert utcában 57 m hosszon áteresz épül, mely a meglévő
          földárokba kerül bevezetésre. A földárkot a növényzet eltávolítását
          követően profilozni kell 114 m hosszon, a megfelelő árokszelvény
          kialakításával. Az árok vize az É felé kanyarodó Kenderkert utca alatt
          átereszben átvezetve kerül a Tekeresi-vízfolyásba vezető árokba,
          melynek csatlakozó 18 m hosszú szakaszát burkolni szükséges. A meglévő
          átjárható folyóka elbontásra kerül és vb. mederelemes árok épül 37 fm
          hosszban, a kapubehajtóban vb. fedlapokkal lefedve. Az árok vize
          átereszen keresztül kerül bevetetésbe az 1. szakaszban megépülő
          Kenderkert utcai átereszbe<br />
          A magasponttól indulva 55 fm hosszon épül beton mederelemes burkolt
          árok a meglévő áteresz csatlakozásig. Ahol nem volt árok, ott újonnan
          kerül kialakításra, ahol meglévő, tönkrement burkolt árok volt, az
          elbontásra kerül és új mederelemes árokburkolat készül, a
          kapubehajtókban vb. fedlapelemekkel lefedve.<br />
          A várható burkolt árok építés összesen kb. 234,9 m hosszban valósul
          meg. Földmedrű árok 114 m hosszban valósul meg.<br /><br />
          A műszaki megoldások mellett a projekt keretében szemléletformálási,
          tájékoztató akciókat tervezünk megvalósítani.<br /><br />
          A projekt eredményei a következők:<br />
          - A fejlesztett infrastruktúra által megvédett lakosság száma: 521
          fő<br />
          - A fejlesztett kék infrastruktúra hossza: 348 méter<br />
          Ebből<br />
          - épített új burkolt árok hossza: 234 m<br />
          - épített új földmedrű árok hossza: 114 m<br />
          A megvédett vagyon becsült értéke: 598.700.000 millió Ft<br /><br />
          A projekt az Európai Unió 100 % támogatásával valósul meg.<br /><br />
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2023/05/kedvezmenyezetti_infoblokk_fekvo_magyar_rgb_page-0001.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2025/06/IMG_20230703_185815.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2025/06/IMG_20230703_190009.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2025/06/IMG_20230703_190017.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2025/06/IMG_20240701_170555.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2025/06/IMG_20240708_203819.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2025/06/IMG_20240711_203439.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2025/06/IMG_20240715_185844.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2025/06/IMG_20240715_185923.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2025/06/IMG_20240715_190144.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2025/06/IMG_20240805_182950.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2025/06/IMG_20240805_182958.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2025/06/IMG_20250318_112422.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-accordion>

  <app-accordion
    title="Magyar Faluprogram keretében 2022 évben meghirdetett „Közösségszervezéshez kapcsolódó eszközbeszerzés és közösségszervező bértámogatása” pályázat"
  >
    <div class="p-3">
      <div class="row">
        <div class="col-12">
          <strong>Kedvezményezett neve:</strong>&nbsp;&nbsp;Dunaszentmiklós
          Község Önkormányzata<br />

          <strong>Projekt címe:</strong>&nbsp;&nbsp;&nbsp;„Közösségszervezéshez
          kapcsolódó eszközbeszerzés és közösségszervező bértámogatása”<br />

          <strong>Igénylés azonosító kódszáma:</strong>&nbsp;MFP-KEB/2022<br />

          <strong>A projekt időtartama</strong>: 2022.04.01 napjától -
          2023.03.31 napjáig.t<br />
          <strong>A támogatás összege</strong>: 2.915.889.- Ftt<br />

          <strong>Támogatás mértéke:</strong>&nbsp;100%<br /><br />

          Dunaszentmiklós Község Önkormányzata pályázatot nyújtott be
          <b
            >Közösségszervezéshez kapcsolódó eszközbeszerzés és közösségszervező
            bértámogatása.</b
          >b> 100% visszanem térítendő támogatásban részesült 2.915.889.- Ft
          bruttó összegben, mely tartalmaz tárgyi eszközbeszerzést: 663.200.-
          Ft, Infokommunikációs eszközök beszerzését: 489.889.-Ft. és
          Bértámogatást egy fő Közművelődési szakember alkalmazására napi 4 óra
          munkavégzésre: 1.762.800.- Ft. értékben.<br /><br />
          Dunaszentmiklós Község büszke a gyökereire, az elődök által képviselt
          értékek továbbvitelére. A Közművelődés egyik fő célja Községünkben a
          civil szervezetek összefogása, melynek segítségével a falu közösségi
          ereje megsokszorozódik. Saját programjaink, projektjeink által
          közösséget építünk, a közös alkotás során egyedivé tesszük a
          programjainkat. Komárom-Esztergom megye egyik legkisebb településének
          nagyon jó esélyei vannak arra, hogy a közösség erejével megtartsa a
          lakosait, és a turisták számára is vonzóvá tegye kirándulási
          célpontként. Ehhez nagy segítség az átgondolt és megtervezett
          közösségszervezés. A programok színvonalas szervezéséhez és
          lebonyolításához szükséges eszközök megvásárlásához kértünk és kaptunk
          pályázati segítséget. Községünkben csupán 2021 évtől van
          közösségszervező, tehát az ehhez a tevékenységhez szükséges irodai
          „bázis” felépítését valósítottuk meg a kapott pályázati támogatás
          segítségével, mivel a tervezett programok minőségi előkészítése és
          lebonyolítása során több különféle eszközre van szükségünk. A
          tájékoztatás és nyilvánosság kötelezettségének eleget téve Támogatói
          Táblát is beszereztünk és jól látható helyre kihelyeztünk.<br /><br />
          <div class="row">
            <div class="col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2023/01/Betűnyomógép .jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2023/01/fénymásoló papír.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2023/01/Flipchart tábla.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2023/01/irodaszer eszközök.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2023/01/laminálógép.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2023/01/laptop és nyomtató  (1).jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-accordion>

  <app-accordion
    title="2020. évi Önkormányzati feladatellátást szolgáló fejlesztések"
  >
    <div class="p-5">
      <div class="row py-3">
        <div class="col-lg-12">
          <b>Kedvezményezett neve: </b>Dunaszentmiklós Község Önkormányzata<br />
          <b>Projekt címe: </b>Belterületi utak, járdák, hidak felújítása<br />
          <b>Igénylés azonosító száma:: </b>488852<br />
          <b>A projekt tervezett befejezési dátuma: </b>2021.12.16.<br />
          <b>A támogatás összege:</b> 20.000.000.- Ft<br />
          <b>Támogatás mértéke: </b>65%<br /><br />

          <b>A projekt tartalmának bemutatása:</b>
          A Petőfi Sándor utca mintegy 690 méter hosszú szakasza, a közlekedés
          és a hegyvidéken jellemző szélsőséges időjárás okozta károk,
          vízelvezetési problémák által jelentősen igénybe vett útvonalon a
          veszélyes területeken korábban kátyús, vízmosásos, helyenként
          repedezett volt a burkolat. Mindezek kijavításával, a burkolat
          felújításával a projekt megvalósítása nagyban hozzájárult a közlekedés
          biztonságához és ezzel életek megóvásához, anyagi károk megelőzéséhez.
          Az útszakasz elhalad a Polgármesteri Hivatal, a Művelődési Ház és
          megannyi családi ház előtt, melyek megközelíthetősége jelentősen
          javult. A Széles Út Kft. elvégezte a helyszínen (Dunaszentmiklós
          Község, Petőfi Sándor utca 55. és 110. szám közötti szakaszán, hrsz.
          281/3) a meglévő aszfalt profilba marását, mely a leromlott állapota,
          vízelvezetési problémák és a megnövekedett teherforgalom miatt vált
          szükségessé. Az aszfalt bontása, új pályaszerkezet építése, új kötő-
          és kopóréteg (szilárd burkolatú aszfalt) terítése és a padka rendezése
          is megvalósult. A tájékoztatás és nyilvánosság kötelezettségének
          eleget téve Támogatói Táblát is beszereztünk és jól látható helyre
          kihelyeztünk.
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2022/01/kezdeti munkálatok.jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2022/01/50 készültség1.jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2022/01/50 készültség4.jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2022/01/100 készültség 10.jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-accordion>

  <app-accordion title="MFP-UHK/2021">
    <div class="p-5">
      <div class="row py-3">
        <div class="col-lg-3">
          <img src="../../../assets/imgs/mfp_logo.png" />
        </div>
        <div class="col-lg-9">
          <b>Kedvezményezett neve: </b>Dunaszentmiklós Község Önkormányzata<br />
          <b>Projekt címe: </b>Út, híd, kerékpárforgalmi létesítmény
          építése/felújítása<br />
          <b>Projekt azonosító száma: </b>MFP-UHK/2021<br />
          <b>A projekt tervezett befejezési dátuma: </b>2021.11.30.<br />
          <b>A támogatás összege:</b> 34.714.342.- Ft<br />
          <b>Támogatás mértéke: </b>100%<br /><br />

          <b>A projekt tartalmának bemutatása:</b>
          „A fejlesztés keretében Dunaszentmiklóson a Faház utca felújítását
          terveztük. A zúzottkővel borított utcában a megfelelő közlekedési
          feltételek biztosítása érdekében szilárd útburkolat kialakítására
          került sor. A fejlesztés keretében a lejtős utca vízelvezetésére is
          gondolva az utca végében egy földárok kialakítása is megvalósult. A
          fejlesztés eredményeként Dunaszentmiklós településen a közlekedési
          feltételek javultak, a felújítással érintett utcában az ingatlanok
          megközelíthetősége javult, ami az ingatlanvásárlási kedvet is
          javíthatja, új lakók településre költözését eredményezve, ezzel pedig
          növelve a település népességmegtartó és népességnövelő erejét. A
          tájékoztatás és nyilvánosság kötelezettségének eleget téve Támogatói
          Táblát is beszereztünk és jól látható helyre kihelyeztünk.”
          <div class="px-5 col-lg-8 mx-auto my-4 text-center">
            <span
              class="dl-span link"
              (click)="
                download(
                  'MUNKÁLATOK fotó dokumentáció galéria.',
                  '.docx',
                  'uploads/2021/12/fotók faház utca'
                )
              "
            >
              MUNKÁLATOK fotó dokumentáció galéria.
            </span>
          </div>
        </div>
      </div>
    </div>
  </app-accordion>

  <app-accordion
    title="Eszközfejlesztés belterületi közterület karbantartása, MFP-KKE/2019"
  >
    <div class="p-5">
      <div class="row py-3">
        <div class="col-lg-3">
          <img src="../../../assets/imgs/mfp_logo.png" />
        </div>
        <div class="col-lg-9">
          Dunaszentmiklós Község Önkormányzata a Magyar Falu Program keretében
          pályázatott nyújtott be a meghirdetett: „Eszközfejlesztés belterületi
          közterület karbantartása” című, MFP-KKE/2019 kódszámú pályázatra. A
          támogatási döntés alapján 6.855.084.- ft. összegű támogatásban
          részesült a Község. A projekt időtartama: 2019.09.01 – 2020.12.15-ig
          tart és a finanszírozása: 100%-os. Dunaszentmiklós a jelen
          beruházással az alapvető közfeladatok ellátása céljából a belterületi
          közterület fenntartását biztosító eszközök beszerzését valósította
          meg. A beszerezni kívánt kis eszközök a közterületek füvesített
          területeinek rendben tartására szolgálnak: házi és kézi motoros
          fűkaszák, fűnyírók, valamint a téli időszakra vonatkozóan hatolólópát
          és sószóró berendezés. Egy településen élők életminőségét nagyban
          befolyásolja a település közterületeinek állapota, jellege és a
          kialakított környezet megjelenése. A rendezett összkép a füvesített
          területek karbantartásával, a telepített sövények formaigazításával
          érhető el. A téli időszakban a z emberek életminőséget alapvetően
          meghatározza, hogy a havazás okozta közlekedési útviszonyok milyenek,
          a település közterület fenntartója milyen gyorsan reagál a kialakult
          terepviszonyokra és az útviszonyok rendezésére.<br />

          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/12/mfp/img (1).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/12/mfp/img (2).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/12/mfp/img (3).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/12/mfp/img (4).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/12/mfp/img (5).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/12/mfp/img (6).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/12/mfp/img (7).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/12/mfp/img (8).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-accordion>

  <app-accordion title="Orvosi eszköz, MFP-AEE/2019">
    <div class="p-5">
      <div class="row py-3">
        <div class="col-lg-3">
          <img src="../../../assets/imgs/mfp_logo.png" />
        </div>
        <div class="col-lg-9">
          Dunaszentmiklós Község Önkormányzata a Magyar Falu Program keretében
          pályázatott nyújtott be a meghirdetett: „Orvosi eszköz, MFP-AEE/2019”
          kódszámú pályázatra. A 2019, július 25.-én kelt támogatási döntés
          alapján 2.089.486.- ft. összegű támogatásban részesült a Község. A
          projekt időtartama: 2019.09.01 – 2020.04.30-ig tart és a
          finanszírozása: 100%-os.<br /><br />

          A projekt keretében az egészségügyi alapellátás eredményességét és
          hatékonyságát javító eszközök kerültek beszerzésre. Az új orvosi
          eszközök beszerzésével a településen élők számára az egészségügyi
          alapellátás feltételei javulnak. Az eszközbeszerzés kapcsolódik a
          pályázó által fejlesztendő egészségügyi szolgálathoz. A működési
          engedélyben és a Nemzeti Egészségbiztosítási Alap kezelő (NEAK)
          finanszírozási szerződésben foglalt tevékenységek végzéséhez
          szükséges, az adott egészségügyi alapellátás biztosításához
          elengedhetetlen műszer, gép, informatikai és egyéb eszközök kerültek
          beszerzésre. A korábbi eszközállomány elavult, hiányos. Jelen
          támogatással a betegek ellátásához szükséges idő lecsökken (modern
          informatikai eszközök), illetve az új orvosi eszközökkel az
          egészségügyi alapellátási rendszer eredményessége javul.<br />

          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (1).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (2).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (3).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (4).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (5).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (6).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (7).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (8).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (9).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (10).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (11).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (12).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (13).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (14).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (15).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (16).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (17).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (18).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (19).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (20).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (21).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (22).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (23).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/10/mfp/img (24).jpg"
                alt="1"
                width="1381"
                height="1037"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-accordion>

  <app-accordion title="EFOP – 1.5.2-16-2017.00043">
    <div class="p-5">
      <div class="row py-3">
        <div class="col-lg-3">
          <img src="../../../assets/imgs/szechenyi_strukt.jpg" />
        </div>
        <div class="col-lg-9">
          <strong>Humán szolgáltatások fejlesztése</strong><br />

          <strong>Magyary Zoltán mintajárásában</strong><br /><br />

          Dunaszentmiklós Község Önkormányzata az Emberi Erőforrás Fejlesztési
          Operatív Program keretében pályázatot nyújtott be „Humán
          szolgáltatások fejlesztése Magyary Zoltán mintajárásban” címmel.<br />

          Az EFOP – 1.5.2-16-2017.00043 azonosító számú pályázatot az Emberi
          Erőforrások Minisztériuma Vezetője 2017.12.04. napon kelt támogatási
          döntés alapján támogatásra érdemesnek ítélte.<br />

          Projekt időtartama: 2018.03.01.-től – 2021.02.28-ig.<br />

          Projekt finanszírozása: 100%<br />

          Támogatás: 5.255.196.- ft<br />

          Támogatói szerződés aláírása: 2018.02.27.<br />

          Kedvezményezett: Dunaszentmiklós Község Önkormányzata<br />

          2897 Dunaszentmiklós, Petőfi S. u. 52 szám. Telefon: +36/34-491-819<br />

          E-mail:
          <a href="mailto:ph@dunaszentmiklós.hu">ph@dunaszentmiklós.hu</a
          ><br /><br />

          A projekt célja: A projekt egyik legfőbb célja a társadalmi
          felzárkózás érdekében a területi különbségek csökkentése, a minőségi
          humán közszolgáltatásokhoz való hozzáférés javítása. A projekt másik
          fő célja a helyi esélyegyenlőségi programokban feltárt problémák
          komplex, a helyi közösségekre és erőforrásokra alapuló kezelését célzó
          területi hatókörű fejlesztési programok megvalósításának támogatása. A
          projekt részcéljai: - A humán közszolgáltatások terén jelentkező
          szakemberhiány enyhítését szolgáló ösztönző programok megvalósítása, -
          A hátrányos helyzetű csoportok foglalkoztathatóságra való
          felkészítésének, munkaerőpiaci eszközökben való részesedésének és
          munkaerő-piacon való megjelenésének elősegítése, - A helyi
          kisközösségek társadalom-szervező szerepének megerősítése, - A vidék
          megtartó képességének erősítése, valamint az ezzel kapcsolatos
          disszemináció támogatása, - A kultúrák közötti párbeszéd erősítése.<br /><br />

          A projekt tartalma: A pályázat konzorcium keretén belül került
          benyújtásra. A konzorcium vezetője Tata Város Önkormányzata,
          konzorciumi tagok: Baj, Dunaszentmiklós, Kocs, Naszály, Szomód,
          Tardos, Vértestolna és a Tatai Televízió Közalapítvány.<br />

          <strong>&nbsp;</strong>

          <strong>Megvalósuló kulturális rendezvények</strong><br />

          <strong><u>Civil szervezetek estje</u></strong> – A rendezvény
          keretében a helyi civil egyesületek, kulturális csoportok,
          alapítványok, kulturális&nbsp; mutatják be munkásságukat, céljaikat,
          programjaikat.<br />

          <strong><u>„Az egészség mindenkié”</u> rendezvény sorozat</strong
          ><br />

          A&nbsp; rendezvénysorozat keretében előadássorozatokat tartunk az
          egészséges élet megőrzéséhez a helyi igényeknek megfelelően.
          Szűrésekhez és megelőzések, életmódbeli tanácsadó segítségével.
          Egészséges ételek elkészítésének bemutatása friss helyi
          alapanyagokból.<br />

          <strong><u>&nbsp;„A mozgás mindenkié”</u> rendezvény sorozat</strong
          ><br />

          Állandó mozgásformák helyi telepítése: Zumba órák.<br />

          <strong><u>Nyugdíjasok aktivitását fenntartó programok</u></strong
          ><br />

          Nyugdíjasok aktív hétköznapi és hétvégi időtöltésének megszervezése.
          Önsegítő klubok kezdeti segítése, hobbi és sportcsoportok segítése.
          Aktív szabadban történő mozgás, kirándulások megvalósításában való
          segítség. Aktív szellemi tevékenység támogatás színház, múzeumok
          látogatásával. Hagyományőrző tevékenység, mesterségek megőrzésében
          támogatás, zene és tánc tevékenységek segítése.<br />

          <strong><u>Szentmiklósi Fesztivál </u></strong><br />

          A hagyományos falunap megrendezése, sváb hagyományok megtartása
          színvonalas rendezvényekkel.<br />

          <strong><u>Testvérvárosi partnerkapcsolat megerősítése</u></strong
          ><br />

          Falunap alkalmával a testvérvárosból érkezők fogadása, elszállásolása.
          Programok, esték szervezése ahol lehetőség nyílik a partnerek
          kapcsolatainak megerősítésére.<br />
          <div class="px-5 col-lg-8 mx-auto my-4 text-center link-list">
            <span
              class="dl-span link"
              (click)="
                download(
                  'Sajtómegjelenés',
                  '.pdf',
                  'uploads/2024/01/Sajtómegjelenés honlapra'
                )
              "
            >
              Sajtómegjelenés
            </span>
            <span
              class="dl-span link"
              (click)="
                download(
                  'Beszámoló projektzárásról',
                  '.pdf',
                  'uploads/2024/01/Beszámoló projektzárásról honlapra'
                )
              "
            >
              Beszámoló projektzárásról
            </span>
          </div>
        </div>
      </div>
    </div>
  </app-accordion>

  <app-accordion title="VP6-7.2.1-7.1.2-16">
    <div class="p-5">
      <div class="row py-3">
        <div class="col-lg-3">
          <img src="../../../assets/imgs/szechenyi_strukt.jpg" />
        </div>
        <div class="col-lg-9">
          <strong>&nbsp;</strong>

          <strong>Dunaszentmiklós Község Önkormányzata</strong>&nbsp;pályázatot
          nyújtott be a Vidékfejlesztési Program keretében a Dunaszentmiklós
          külterületi utak felújítása című kiírásra.<br />

          A&nbsp;<strong>VP6-7.2.1-7.1.2-16&nbsp;</strong>számon nyilvántartásba
          vett pályázatot támogatásra érdemesnek ítélték.<br />
          A projekt tervezett kezdési időpontja: 2019.03.25.<br />
          Tervezett záró időpont: 2019.11.30.<br />

          A projekt finanszírozása:<br />
          Összes költség: 91 458 583.-Ft<br />
          Támogatás:77 739&nbsp;792.-Ft<br />
          Saját erő:13 718&nbsp;791.-Ft<br /><br />

          &nbsp;A tervek szerint a fejlesztés négy nyomvonalon valósul meg.
          <br />Az 1. nyomvonal a Dunaszentmiklós és Szomód közötti közvetlen
          összeköttetést is biztosító út Dunaszentmiklósi szakasza, ami
          közvetlenül nem kapcsolódik a másik három fejlesztendő nyomvonalhoz.
          <br />A 2.-4. nyomvonal a Dunaalmási kőfejtők felé vezető részen
          meglévő utakat érinti, mely útszakaszok közvetlenül kapcsolódnak
          egymáshoz. <br />A projekt során összesen 1131 m aszfalt burkolatú és
          1628 m zúzott kő burkolatú útpálya kerül kialakításra.<br /><br />

          &nbsp;

          <strong><u>A fejlesztés részletes szakmai tartalma</u></strong
          ><br />

          A tervek szerint a fejlesztés a rövid összefoglaló szerinti négy
          nyomvonalon valósul meg. A beruházás során kiemelt szegélyt nem
          terveztünk, az útburkolat építés nagymértékben alkalmazkodik a meglévő
          terepszinthez, így nagyobb bevágás és töltés a beruházás során nem
          létesül, nem alakul ki nagyobb felületű rézsű. Az utak mindkét oldalán
          0,50- 0,50 cm földpadka kerül kialakításra, a burkolattól 4%-os
          lejtéssel.<br />

          A tervezett útszakaszok forgalma kitérés lehetőségével kétirányú, a
          csomópontok mindegyike szintbeli csatlakozásként kerül kialakításra
          egyenrangú kereszteződésként. A csomópontok kialakításával biztosított
          a teljes tervezett szakaszon a kerékpárok akadálytalan közlekedése, de
          konkrét kerékpáros sáv kijelölés, átvezetés nem történik.
          <ol>
            <li>
              <strong><u> nyomvonal:</u> </strong>Összesen 786 m hosszú, 3,00 m
              széles aszfalt burkolatú út alakítandó ki, az aszfalt burkolat
              csésze szelvényként kerül kialakításra, hogy a csapadék az út
              tengelyében folyjon, és ne mossa alá a burkolat szélét, a burkolat
              oldalesés 1,50% az út tengelye felé. A tervezett nyomvonalon a
              meglévő földutat 35 cm vastag mechanikai stabilizációval és 6 cm
              aszfalt burkolattal terveztük ellátni, a településhatár és a 0+760
              szelvényszám között „K” szegély is épül.
            </li>
            <li>
              <strong><u> nyomvonal: </u></strong>Összesen 345 m hosszú, 3,00 m
              széles aszfalt burkolatú út alakítandó ki, a pályaszerkezet: 6 cm
              AC 11 kopó réteg, 10 cm M22 és 25 cm M56 útépítési zúzottkő.
              Aszfalt burkolat csésze szelvényként kerül kialakításra 1,50 %
              burkolat oldaleséssel az út tengelye felé, az út hosszesése 10-15
              % között változik. A szükséges szakaszokon talajtól függően két
              féle talajjavítást tervezünk, az M56 zúzott kő alá közvetlenül az
              előre elkészített úttükörbe 1 rtg. georács és 1 rtg geotextilia
              kerül, szükség esetén a geotextilia alá további 10-20 cm vtg.
              homokos kavics talajréteget teszünk. A 0+080-0+200 szelvény között
              az Önkormányzati tulajdonú úttelekre kerül vissza a tervezett út
              nyomvonala az előírtaknak megfelelően, mely a meglévő bozótos
              terület irtásával alakul ki.
            </li>
            <li>
              <strong><u> nyomvonal: </u></strong>Összesen 1222 m hosszú, 2,75m
              széles zúzott kő burkolatú út épül 0,50-0,50 m padkával, a
              pályaszerkezete: 10 cm M22 és 25 cm M56 útépítési zúzottkő. A
              tervezett nyomvonal a meglévő út nyomvonalán halad, a szelvényezés
              szerinti baloldalra 2% -kal lejt az út.
            </li>
            <li>
              <strong><u> nyomvonal: </u></strong>Összesen 406 m hosszú, 2,75m
              széles zúzott kő burkolatú út épül 0,50-0,50 m padkával, a
              pályaszerkezete: 10 cm M22 és 25 cm M56 útépítési zúzottkő. A
              tervezett nyomvonal a meglévő út nyomvonalán halad, a szelvényezés
              szerinti jobb oldalra 2% -kal lejt az út. A talajtól függően két
              féle talajjavítást tervezünk, az M56 zúzott kő alá közvetlenül az
              előre elkészített úttükörbe 1 rtg. georács és 1 rtg geotextilia
              kerül, szükség esetén a geotextilia alá további 10-20 cm vtg.
              homokos kavics talajréteget teszünk. Bozótirtásra és fakivágásra
              is szükség van több szakaszon, mert a növényzet nagymértékben az
              út űrszelvényébe lóg/nőtt.
            </li>
          </ol>
          <div class="h6 content-title text-center py-3">
            Munkálatok megkezdése
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/IMG-3a751fb334a2758171064aee12a53786-V1.jpg"
                alt="IMG-3a751fb334a2758171064aee12a53786-V(1)"
                width="1280"
                height="960"
              />
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/IMG-7cd4017be8994b27b308e7926507fc9b-V1.jpg"
                alt="IMG-7cd4017be8994b27b308e7926507fc9b-V(1)"
                width="1280"
                height="960"
              />
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/IMG-2580a59d3531756008ef70a0f798ba5e-V.jpg"
                alt="IMG-2580a59d3531756008ef70a0f798ba5e-V"
                width="1280"
                height="960"
              />
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/IMG-892d96bf39a50f335ccc4867b35622fe-V1-m†solata.jpg"
                alt="IMG-892d96bf39a50f335ccc4867b35622fe-V(1) m†solata"
                width="1280"
                height="960"
              />
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/IMG-4056f23a6178a9c7706ac781ef71d9ce-V1.jpg"
                alt="IMG-4056f23a6178a9c7706ac781ef71d9ce-V(1)"
                width="1280"
                height="960"
              />
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/IMG-ce2f3aff2db5bec0e606e1640a410e7d-V1.jpg"
                alt="IMG-ce2f3aff2db5bec0e606e1640a410e7d-V(1)"
                width="960"
                height="1280"
              />
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/IMG-d85e4285663f790ae7daad8783d4f268-V.jpg"
                alt="IMG-d85e4285663f790ae7daad8783d4f268-V"
                width="960"
                height="1280"
              />
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/IMG-cdeae9ff646857e62573bb28e82d4ec8-V1.jpg"
                alt="IMG-cdeae9ff646857e62573bb28e82d4ec8-V(1)"
                width="960"
                height="1280"
              />
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/IMG-f32a7082dac986ed1e88bb5ba576f651-V1.jpg"
                alt="IMG-f32a7082dac986ed1e88bb5ba576f651-V(1)"
                width="960"
                height="1280"
              />
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/IMG-a1258219cc21c287ff8472b00c4921af-V.jpg"
                alt="IMG-a1258219cc21c287ff8472b00c4921af-V"
                width="960"
                height="1280"
              />
            </div>
          </div>
          <div class="h6 content-title text-center py-3">50%-os készültség</div>
          <div class="row">
            <div class="col-lg-3 col-md-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/IMG-5cf2ce824273ec94f80e904e750fee4c-V.jpg"
                alt="IMG-5cf2ce824273ec94f80e904e750fee4c-V"
                width="1280"
                height="960"
              />
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/IMG-892d96bf39a50f335ccc4867b35622fe-V1-m†solata.jpg"
                alt="IMG-892d96bf39a50f335ccc4867b35622fe-V(1) m†solata"
                width="1280"
                height="960"
              />
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/IMG-7fa5fa500adc04b2423d5c80c728067b-V.jpg"
                alt="IMG-7fa5fa500adc04b2423d5c80c728067b-V"
                width="1280"
                height="960"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-accordion>

  <app-accordion title="TOP-1.2.1-16-KO1-2017-00001">
    <div class="p-5">
      <div class="row py-3">
        <div class="col-lg-3">
          <img src="../../../assets/imgs/erfa.jpg" />
        </div>
        <div class="col-lg-9">
          <b>Kedvezményezett neve: </b> Neszmélyi Borút Egyesület<br />
          <b>Konzorciumi tagok neve:</b> Neszmélyi Borút Egyesület, Baj Község
          Önkormányzata, Dunaszentmiklós Község Önkormányzata<br />
          <b>Projekt címe: </b>„A tájban élő ember” Ökoturisztikai
          látogatópontok a Nyugat-Gerecsében<br />
          <b>Projekt azonosító száma: </b>TOP-1.2.1-16-KO1-2017-00001 <br />
          <b>A projekt tervezett befejezési dátuma: </b>2021.11.30.<br />
          <b>A támogatás összege:</b> 57 000 000 Ft<br />
          <b>Támogatás mértéke: </b>100%<br /><br />

          <b>A projekt tartalmának bemutatása:</b>
          Dunaszentmiklós Község Önkormányzata egy kültéri bemutató tér
          létrehozását valósította meg a település pincesorán.<br />
          Dunaszentmiklós 077/1 hrsz-en kialakításra került egy kültéri
          pihenőhely, kerékpáros pihenőhely. A beruházás során az alábbi építési
          munkák zajlottak a területen:<br />
          - építési munkák: durva tereprendezés az építéssel érintett területen
          a kikerült talaj felhasználásával, tükörkiemelés térkő burkolatok
          alatt átlag 34 cm-es vastagságban, a kikerülő talaj töltésnek
          felhasználásával, burkolat tükrök tömörítése, beton kerti szegély
          építése helyszínen készített betongerendába, 100x20x5 cm méretben,
          földmunkával, vágási veszteség nélkül; fagyálló térkő burkolat
          készítése finom kopórétegű 6 cm vastag beton térkőből, alépítményi
          munkákkal, 25 cm zúzottkő alépítménnyel, 3 cm fektető zúzalékkal,
          finom tereprendezés építési területen<br />
          - utcabútorok beszerzése és kihelyezése: ismeretterjesztő tábla
          beszerzése 2 db, kihelyezése, fedett zsindelytetős pad-asztal
          kombináció egyedi gyártása, kihelyezése (2 db), egyedi kerékpártároló
          beszerzése, kihelyezése<br />
          - tereprendezés <br />
          - növénytelepítés<br /><br />

          A pihenőhely alkalmas az aktív turisták fogadására, valamint a busszal
          érkező, vagy a kerékpárral érkező látogatók fogadására is. Itt halad
          el az Eurovelo 6 nemzetközi kerékpárút is.

          <div class="h6 content-title text-center py-3">
            Munkálatok megkezdése
          </div>
          <div class="row">
            <div class="col-lg-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/01.png"
                alt="01"
                width="606"
                height="459"
              />
            </div>
            <div class="col-lg-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/03.png"
                alt="03"
                width="603"
                height="458"
              />
            </div>
            <div class="col-lg-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/02.png"
                alt="02"
                width="606"
                height="456"
              />
            </div>
          </div>
          <div class="h6 content-title text-center py-3">50%-os készültség</div>
          <div class="row">
            <div class="col-lg-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/04.png"
                alt="04"
                width="608"
                height="454"
              />
            </div>
            <div class="col-lg-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/06.png"
                alt="06"
                width="600"
                height="453"
              />
            </div>
            <div class="col-lg-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/05.png"
                alt="05"
                width="602"
                height="448"
              />
            </div>
          </div>
          <div class="h6 content-title text-center py-3">
            100%-os készültség
          </div>
          <div class="row">
            <div class="col-lg-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/07.png"
                alt="07"
                width="608"
                height="454"
              />
            </div>
            <div class="col-lg-4 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/08.png"
                alt="08"
                width="604"
                height="452"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-accordion>

  <app-accordion title="TOP-2.1.3-15-KO1-2016-00010">
    <div class="p-5">
      <div class="row py-3">
        <div class="col-lg-3">
          <img src="../../../assets/imgs/szechenyi_strukt.jpg" />
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/TOP_2.1.3-15_Plakát_Dunaszentmiklós.png"
            alt="center"
          />
        </div>
        <div class="col-lg-9">
          <strong>Kedvezményezett neve:</strong>&nbsp;&nbsp;Dunaszentmiklós
          Község Önkormányzata<br />

          <strong>Projekt címe:</strong>&nbsp;&nbsp;&nbsp; Dunaszentmiklós
          csapadékvíz-elvezetésének fejlesztése<br />

          <strong>Projekt azonosító száma:</strong
          >&nbsp;TOP-2.1.3-15-KO1-2016-00010<br />

          <strong>&nbsp;A projekt tervezett befejezési dátuma</strong>:
          2019.10.01.<br />

          <strong>A támogatás összege</strong>: 42 957 500 Ft<br />

          <strong>Támogatás mértéke:</strong>&nbsp;100%<br /><br />

          &nbsp;

          <strong>A projekt tartalmának bemutatása:</strong><br /><br />

          A projekt célja a Neszmélyi út keleti oldalán meglévő 172.5 méter
          hosszú, rossz hatásfokkal üzemelő nyílt medrű csapadékvíz elvezető
          árok felújítása, rendezése, burkolása és a meglévő vízfolyásba történő
          bekötésének rendezése. A beruházás keretében a meglévő szakasz
          egyenetlen, rossz állapotban lévő medrének helyes geodéziai, és
          helyszínrajzi vonalvezetésének kialakítása, burkolása eredményeként az
          érintett szakaszon elhelyezkedő ingatlanok környezetében megelőzhető a
          csapadékvíz telkek irányába történő tovább haladása, valamint az
          összegyűjtött vizek útpályaszerkezeten történő lezúdulása. A tervezett
          beruházás a szakasztól északra elhelyezkedő meredek domboldal vizeinek
          elvezetését is elősegíti. Az árok végpontján, a meglévő vízfolyásba
          való bekötésének rendezése az összegyűjtött csapadékvizek
          visszaduzzasztás nélküli elvezetését biztosítja. A rekonstrukciós
          munkálatokon áteső átereszek képesek lesznek a beérkező csapadék
          továbbítására a befogadó irányába. A szakasz felújítási munkálatainak
          eredményeként nem csak a közvetlenül a szakasz közelében, hanem attól
          délre, a Petőfi Sándor utca útpályaszerkezete, és a területen
          elhelyezkedő ingatlanok vízkár veszélyeztetése jelentősen
          csökkenthető.<br /><br />
          „Dunaszentmiklós csapadékvíz-elvezetésének fejlesztése” tárgyú Kbt.
          115.§(1) bekezdés szerinti nemzeti eljárásrendben a közbeszerzési
          eljárást lefolytattunk, szerződést megkötöttük a kivitelezővel.
          <br /><br />
          További tájékoztatást Dunaszentmiklós csapadékvíz -elvezetésének
          fejlesztéséről itt talál:
          <b
            ><span
              class="link"
              (click)="
                download(
                  'Ismeretterjesztő a jó csapadékvíz-gazdálkodási gyakorlatról',
                  null,
                  'uploads/2021/03/top_2.1.3-15_kiadvány_dunaszentmiklós'
                )
              "
              >Ismeretterjesztő a jó csapadékvíz-gazdálkodási gyakorlatról</span
            ></b
          ><br />
          <b
            ><span
              class="link"
              (click)="
                download(
                  'Plakát a jó csapadékvíz-gazdálkodási gyakorlatról',
                  null,
                  'uploads/2021/03/top_2.1.3-15_plakát_dunaszentmiklós'
                )
              "
              >Plakát a jó csapadékvíz-gazdálkodási gyakorlatról</span
            ></b
          ><br /><br />

          <div class="h6 content-title text-center py-3">
            Munkálatok megkezdése
          </div>
          <div class="row">
            <div class="col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/4.mell_jelenlegi_állapot.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/4.mell_jelenlegi_állapot-3.jpg"
                alt="4.mell_jelenlegi_állapot (3)"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/4.mell_jelenlegi_állapot-2.jpg"
                alt="4.mell_jelenlegi_állapot (2)"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/4.mell_jelenlegi_állapot-4-e1556366181334.jpg"
                alt=""
              />
            </div>
          </div>
          <div class="h6 content-title text-center py-3">50%-os készültség</div>
          <div class="row">
            <div class="col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2018/2.jpg"
                alt="2"
                width="1013"
                height="760"
              />
            </div>
          </div>
          <div class="h6 content-title text-center py-3">
            100%-os készültség
          </div>
          <div class="row">
            <div class="col">
              <b
                ><span
                  class="link"
                  (click)="
                    download(
                      'Tájékoztató 100%-os készültségről',
                      null,
                      'uploads/2021/03/100_kesz'
                    )
                  "
                  >Tájékoztató 100%-os készültségről</span
                ></b
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-accordion>

  <app-accordion title="TOP-3.2.1-15-KO1-2016-00008">
    <div class="p-5">
      <div class="row py-3">
        <div class="col-lg-3">
          <img src="../../../assets/imgs/szechenyi_strukt.jpg" />
        </div>
        <div class="col-lg-9">
          <strong>Kedvezményezett neve:</strong> Dunaszentmiklós Község
          Önkormányzata<br />

          <strong>Projekt címe:</strong> Energetikai korszerűsítés
          Dunaszentmiklóson<br />

          <strong>Projekt azonosító száma:</strong>
          TOP-3.2.1-15-KO1-2016-00008<br />

          <strong>&nbsp;A projekt befejezési dátuma</strong>: 2019.08.31<br />

          <strong>A támogatás összege</strong>: 38 398&nbsp;156 Ft<br />

          <strong>Támogatás mértéke:</strong> 100%<br /><br />

          <strong>A projekt tartalmának bemutatása:</strong><br /><br />

          &nbsp; &nbsp; Dunaszentmiklós Község Önkormányzata a polgármesteri
          hivatal épületének energetikai korszerűsítését valósítja meg jelen
          projekt keretében. Az épület szerkezeteiben és energiafogyasztó
          rendszerében egyaránt erősen elavult, az elmúlt évtizedekben jelentős
          energetikai felújítás nem történt. Az intézmények fenntartása jelentős
          összegbe kerül a községnek, a használati komfort pedig nem éri el a
          mai elvárható szintet. Az épületek akadálymentes használata jelenleg
          nem megoldott. A projekt céljai egybeesnek a pályázati kiírásban
          megfogalmazottakkal, azaz az energiafogyasztás és CO<sub>2</sub>
          kibocsátás jelentős csökkentése, a megújuló energia használata,
          valamint az épületek akadálymentesítésének elvégzése valósul meg.<br />

          A projekttel érintett épület több szakaszban épült, egyik kapcsolódó
          részében korábban kultúrházként funkcionált, nyeregtetős, kétszintes
          épület jelenlegi állapotában az aktuális energetikai követelményeknek
          nem felel meg, jelenleg GG (294,9 %) energiahatékonysági osztályú. A
          projekt keretében a hivatal épületének hozzáférhetőségét lehetővé tevő
          komplex akadálymentesítés is megtörténik. A projektben érintett épület
          (a polgármesteri hivatal épülete) jelenlegi állapotában
          energiafelhasználás tekintetében nem hatékony, hőszigetelés az
          épületeken nincs, a fűtési rendszerek minden részelemükben elavultak
          és energiapazarlók.<br />

          Jelen projekt célja az épület hatékonyabb energiafelhasználásának,
          racionálisabb energiagazdálkodásának elősegítése, összhangban a
          területi szereplők Kormány által elfogadott integrált területi
          programjaival.
          <div class="h6 content-title text-center py-3">
            Munkálatok megkezdése
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/1.jpg"
                alt="1"
                width="4160"
                height="2336"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/2.jpg"
                alt="2"
                width="3968"
                height="2240"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/3.jpg"
                alt="3"
                width="2240"
                height="3968"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/4.jpg"
                alt="4"
                width="2336"
                height="4160"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/5.jpg"
                alt="5"
                width="4160"
                height="2336"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/6.jpg"
                alt="6"
                width="3968"
                height="2240"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/7.jpg"
                alt="7"
                width="4160"
                height="2336"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/8.jpg"
                alt="8"
                width="3968"
                height="2240"
              />
            </div>
          </div>
          <div class="h6 content-title text-center py-3">Felújítás előtt</div>
          <div class="row">
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/07/atalakit (1).jpg"
                alt="504"
                width="2240"
                height="3968"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/07/atalakit (2).jpg"
                alt="504"
                width="2240"
                height="3968"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/07/atalakit (3).jpg"
                alt="504"
                width="2240"
                height="3968"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/07/atalakit (4).jpg"
                alt="504"
                width="2240"
                height="3968"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/07/atalakit (5).jpg"
                alt="504"
                width="2240"
                height="3968"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2020/07/atalakit (6).jpg"
                alt="504"
                width="2240"
                height="3968"
              />
            </div>
          </div>
          <div class="h6 content-title text-center py-3">50%-os készültség</div>
          <div class="row">
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/504.jpg"
                alt="504"
                width="2240"
                height="3968"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/505.jpg"
                alt="505"
                width="2240"
                height="3968"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/502.jpg"
                alt="502"
                width="2240"
                height="3968"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/501.jpg"
                alt="501"
                width="3968"
                height="2240"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/503.jpg"
                alt="503"
                width="3968"
                height="2240"
              />
            </div>
          </div>
          <div class="h6 content-title text-center py-3">
            100%-os készültség
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/104.jpg"
                alt="104"
                width="2240"
                height="3968"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/101.jpg"
                alt="101"
                width="3968"
                height="2240"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/103.jpg"
                alt="103"
                width="3968"
                height="2240"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/102.jpg"
                alt="102"
                width="3968"
                height="2240"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/106.jpg"
                alt="106"
                width="3968"
                height="2240"
              />
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2019/11/105.jpg"
                alt="105"
                width="2240"
                height="3968"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-accordion>

  <app-accordion
    title="TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és kohézió erősítése” Tata és környéke borvidékén"
  >
    <div class="p-5">
      <h6>
        Tata Város Önkormányzata a 290/2017. (IX.11.)Tata Kt. határozata alapján
        a Terület és Településfejlesztési Operatív Program keretében pályázatot
        nyújtott be „Helyi identitás és kohézió erősítése”Tata és környéke
        borvidékén” címmel konzorciumban a Baj, Szomód, Neszmély,Dunaalmás és
        Dunaszentmiklós településsel.<br />
        A projekt célja, hogy a konzorcium területén élők közösségi identitása –
        mint Tata és környéke borvidékhez tartozó települések lakosainak –
        kialakuljon és erősödjön, segítségül hívva ehhez a közösségfejlesztés
        különböző eszközeit, a közösségi részvételre épülő tervezési
        gyakorlatokat, közösségfejlesztő programokat, kiegészülve bűnmegelőzési,
        közbiztonsági és közlekedésbiztonsági programokkal.
      </h6>

      <u><h3>Fórum</h3></u><br /><br />
      Tata Város Önkormányzata a 290/2017. (IX.11.)Tata Kt. határozata alapján a
      Terület és Településfejlesztési Operatív Program keretében pályázatot
      nyújtott be „Helyi identitás és kohézió erősítése” Tata és környéke
      borvidékén” címmel konzorciumban a Baj, Szomód, Neszmély, Dunaalmás és
      Dunaszentmiklós településsel. A projekt célja, hogy a konzorcium területén
      élők közösségi identitása – mint Tata és környéke borvidékhez tartozó
      települések lakosainak – kialakuljon és erősödjön, segítségül hívva ehhez
      a közösségfejlesztés különböző eszközeit, a közösségi részvételre épülő
      tervezési gyakorlatokat, közösségfejlesztő programokat, kiegészülve
      bűnmegelőzési, közbiztonsági és közlekedésbiztonsági programokkal.
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2024. december 18- án rendeztük meg
      a Fórum nevű rendezvényt. A Fórum célközönsége községünk lakói voltak.
      Fórum témája:<br /><br />
      Visszatekintés a kezdetekre.<br />
      Fő téma: Visszaemlékezés az megvalósult programokra. Ki mire emlékszik
      játékra invitáltam a jelenlévőket. Egy rövid szóbeli ráhangoló beszéd
      felidézte a három év alatt megvalósult programokat. Felelevenítettük
      többek között a Mesedélutánokat, Forumokat, Szemétszüretet,
      Horgászversenyt, Őszi túrát, Borversenyt.<br />
      Reflexió: 2024. december 18-án a Fórum alkalmán megállapítást nyert, hogy
      településünk hálás a „Helyi identitás és kohézió erősítése” Tata és
      környéke borvidékén” című pályázatnak. A pályázta célját elérte, mivel a
      fiatalok számára településünk egyre vonzóbb lett, akik aktívan részt
      vesznek a közösségi élet fenntartásában. Ismételten hangot kapott az
      összefogás kivételes jelenléte községünkben.<br /><br />
      A rendezvényen 9 fő vett részt.<br /><br />

      Mondanivalójában gazdag és jó hangulatú találkozó, program volt!
      <br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2025/01/20241218 (1).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2025/01/20241218 (2).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2025/01/20241218 (3).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Fórum</h3></u><br /><br />
      Tata Város Önkormányzata a 290/2017. (IX.11.)Tata Kt. határozata alapján a
      Terület és Településfejlesztési Operatív Program keretében pályázatot
      nyújtott be „Helyi identitás és kohézió erősítése” Tata és környéke
      borvidékén” címmel konzorciumban a Baj, Szomód, Neszmély, Dunaalmás és
      Dunaszentmiklós településsel. A projekt célja, hogy a konzorcium területén
      élők közösségi identitása - mint Tata és környéke borvidékhez tartozó
      települések lakosainak -21-KO1-2022-00015 kialakuljon és erősödjön,
      segítségül hívva ehhez a közösségfejlesztés különböző eszközeit, a
      közösségi részvételre épülő tervezési gyakorlatokat, közösségfejlesztő
      programokat, kiegészülve bűnmegelőzési, közbiztonsági és
      közlekedésbiztonsági programokkal. Konzorciumi tagként a
      TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és kohézió erősítése Tata és
      környéke borvidékén pályázatban részesült Dunaszentmiklós Község
      Önkormányzata. 2023. július 28-án rendeztük meg a Fórum nevű rendezvényt.
      A Fórum célközönsége községünk lakói voltak. Fórum témája:<br /><br />
      Visszatekintés a kezdetekre.<br />
       Fő téma: Visszaemlékezés: „Dunaszentmiklós húsz év múlva kiváló
      közbiztonságú, jól működő falugondnoki szolgálattal rendelkező település,
      mely vonzó a fiatal, gyermekes családok számára, és az itt élő idős
      korosztálynak is azáltal, hogy erős közösségi életet tart fenn az egyház,
      a civil szervezetek, és az önkormányzat szoros együttműködésével ápolva a
      sváb hagyományokat, a borkultúrát, és a természet közeli turizmust. „<br />
       Reflexió: 2023. július 28-án a Fórum alkalmán megállapítást nyert, hogy
      településünk egyre vonzóbb a fiatalok számára, sok fiatal választotta az
      utóbbi időben kis községünket letelepedés céljából. A születendő gyermekek
      száma is megnőtt, mely az öröm mellett feladatot is rejt magában
      számunkra, hagyományőrzők számára: lesz kinek továbbörökbíteni a sváb
      hagyományokat, a borkultúrát. Hangot kapott az összefogás kivételes
      jelenléte községünkben, ami alatt értendő, hogy a falugondnoki
      tevékenységet a civil szervezetek egyre aktívabban megtámogatják. S csak
      remélni tudjuk, hogy húsz év múlva is kiváló közbiztonságú településnek
      tudhatjuk be Dunaszentmiklós községet.<br /><br />
      A rendezvényen 17 fő vett részt.<br /><br />

      Mondanivalójában gazdag és jó hangulatú találkozó, program volt!
      <br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2023/08/2023.08.28.1..jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2023/08/2023.08.28.2..jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2023/08/2023.08.28.3..jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Kétnapos „Nyitott pincék”</h3></u><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2022. augusztus 5-én és 6-án. Az
      Öreghegyben első alkalommal rendeztük meg a kétnapos „Nyitott pincék”
      programot. Egy kis történeti visszatekintés:<br /><br />
      Dunaszentmiklóson a jó természeti adottságoknak köszönhetően számos
      szőlőfajta képviselteti magát a nagy és kis boros gazdák tulajdonában.<br />
      A Kősziklás Borászatot 2008-ban két jó barát hozta létre Dunaszentmiklós
      székhellyel. A borászat elindításának elsődleges célja az volt, hogy a
      borvidék értékeit megismertessék a borkedvelő környezetükkel,
      pincészetükben - mely a közeli „Kősziklás” dűlőről kapta a nevét.<br />
      Borvidék: Neszmély<br />
      Dűlők: Kősziklás<br />
      Szőlőfajták: Királyleányka, Irsai Olivér, Olaszrizling, Sauvignon blanc,
      Rajnai rizling, Sárga muskotály, Cserszegi fűszeres, Rizligszilváni,
      Chardonnay, Pinot blanc, Juhfark, Pinot noir, Merlot, Cabernet
      sauvignon<br />
      Talaj: Löszös barna erdőtalaj, mészkő, homokkő és dolomit.<br />
      Borkészítés: „Döntően friss, üde, gyümölcsös fehér- illetve rozéborok
      készülnek. De készítenek borvidék értékét, potenciálját jól tükröző
      testes, fahordóban erjesztett és érlelt borokat is. Kísérletező
      borászatként szeretnék egyes évjáratokból a rájuk jellemző kézműves
      borokat, igazi borkülönlegességeket is alkotni.”<br />
      Tulajdonosok: Béger Ákos Imre és Emmer Szabolcs<br /><br />

      A Gottwald Borászat, Gottwald Szilárd vezetésével a neszmélyi borvidéken 2
      hektáron, Dunaszentmiklóson található. Kezdetekben az édesapa hobbi
      pincéjéből kinőtt családi borászat hátterét a Gottwald vendéglős dinasztia
      adja, akiknek generációk óta vendéglátás vér folyik az ereikben.<br /><br />

      Továbbá büszkén elmondhatjuk, hogy a Weinrebe Dunaszentmiklós Boregyesület
      képviseletében jelenleg már a helyi kis boros gazdáknak is van
      lehetőségük<br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/08/2022080506k1.jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/08/2022080506k2.jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/08/2022080506k3.jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/08/2022080506k4.jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/08/2022080506k5.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/08/2022080506k6.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/08/2022080506k7.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Mesedélután - 2022.07.05.</h3></u><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2022. július 5.-én tizenkettedik
      alkalommal rendeztük meg a Mesedélután nevű programot. A rendezvény
      helyszíne a dunaszentmiklósi Tájház volt. A rendezvényre szép színes
      meghívót készítettem. A programon 20 fő vett részt.<br /><br />
      „ Die schwabische Küche”- Takarékosság és egyszerűség – katolikus
      keresztény vallásunk a múltban programról röviden:<br />
      Ráhangoló beszélgetéssel indult a foglalkozás, melynek témája a
      takarékosság és az egyszerűség volt.<br /><br />
      Az érintett témák:<br />
      Legnagyobb bűn a kenyér kidobása volt.<br />
      A megmaradt étel hidegen is finom.<br />
      Állattartás, növénytermesztés.<br /><br />
      A gyerekeke szívesen bekapcsolódtak a beszélgetésbe. Hartmann Károlyné
      Edit néni korhű népviseletben fogadott bennünket és mesélt az ő
      gyermekkorának szokásairól, hogy ő kitől tanult meg főzni, honnan, kiktől
      szerezték be az alapanyagokat, mik voltak a leggyakoribb alapanyagok.<br />
      Ezután a tisztaszobában elimádkoztuk az étkezés előtti és étkezés utáni
      imát is.<br /><br />
      Étkezés előtti ima:<br />
      „Komm, Herr Jesu, sei unser Gast und segne, was du uns gegeben hast.
      Amen”<br />
      „Édes Jézus légy vendégünk, áldd meg amit adtál nékünk. Amen”<br /><br />
      Étkezés utáni ima:<br />
      „Wir danken dir, Herr Jesus Christ, dass du unser Gast gewesen bist.<br />
      Errette uns aus aller Not, du bist das wahre Lebensbrot Amen”<br /><br />
      „Köszönjük Édes Jézus, hogy vendégünk voltál. Ments meg minden ínségtől ,
      Te vagy az élet Amen”<br /><br />
      A folytatásban a gyerekek csoportokban egy-egy borítékot kaptak, melyben
      egy kirakó darabjait találhatták. A képen egy régi sváb konyha volt
      található. Majd minden csoportnak egy heti sváb menüt kellett
      összeállítania.<br /><br />
      A vallási hovatartozás megerősítése, a múltbéli emlékek felelevenítése
      mind sikeressé tette a tizenkettedik Mesedélutánt.<br /><br />
      Az utókor nemzedéke ismételten betekintést nyerhetett elődeink életébe. A
      TOP-5.3.1-16-KO1- 2017-00002 Helyi identitás és kohézió erősítése Tata és
      környéke borvidékén pályázat ismét lehetővé tette, hogy a gyerekek tovább
      tudják vinni a sváb hagyományokat.<br /><br /><br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/07/20220705 (1).jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/07/20220705 (2).jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/07/20220705 (3).jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Mesedélután - 2022.06.04.</h3></u><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2022. június 4.-én tizenegyedik
      alkalommal rendeztük meg a Mesedélután nevű programot. A rendezvény
      helyszíne a dunaszentmiklósi Tájház volt. A rendezvényre szép színes
      meghívót készítettem. A programon 10 fő vett részt.<br /><br />
      „ Ha a régi játékok mesélni tudnának” programról röviden:<br /><br />
      Ráhangoló beszélgetéssel indult a foglalkozás. Megválaszoltuk a következő
      kérdéseket:<br />
      Kinek mi a kedvenc a játéka?<br />
      Kivel szeret családon belül játszani a legszívesebben és miért?<br />
      Ki a legjobb barátja, barátnője?<br />
      Vele mit játszik és mivel a leszívesebben?<br />
      A gyerekeke szívesen válaszoltak a kérdésekre, lelkes mesélésébe kezdte.
      Majd én magam is elmeséltem az én időmben milyen is volt gyereknek lenni s
      bemutattam a tájházban lévő játékokat, s hogy azzal kik és hogyan
      játszottak. A helyszínváltoztatásnak az oka az volt, hogy így élethűbben
      tudtam megtartani a mesedélutánt. A játékok és munkaeszközök szemléltetése
      is kézzelfoghatóbb volt. A játékok közül a fiúknál a falovacska a
      lányoknál a babakocsi aratott nagy sikert. S hogy fokozzuk a hangulatot a
      gyerekeke részére a felnőttek népviseletben érkezetek a rendezvényre.<br /><br />
      Mielőtt meglátogattuk volna a tisztaszobát a következő kérdésekre kerestük
      a választ: Ki mivel szeretne foglalkozni felnőttként?<br />
      Ki milyen foglalkozást, mesterséget ismer még a felsoroltakon kívül?<br />
      Mit gondoltok régen a dédik idejében mi volt a foglalkozásuk a nőknek, s
      mi a férfiaknak?<br />
      Ezután bemutattam és meséltem a tisztaszobában található munkaeszközökről.
      A tárgyakat a gyerekeke felügyelet mellett kezükbe vehették. A
      munkaeszközök közül a fiúknál a cipész mesterség míg a lányoknál a
      dagasztóteknő keltette fel leginkább az érdeklődést.<br /><br />
      A vallási hovatartozás megerősítése, a múltbéli emlékek felelevenítése
      mind sikeressé tette a tizenegyedik Mesedélutánt.<br /><br />
      Az utókor nemzedéke ismételten betekintést nyerhetett elődeink életébe. A
      TOP-5.3.1-16- KO1-2017-00002 Helyi identitás és kohézió erősítése Tata és
      környéke borvidékén pályázat ismét lehetővé tette, hogy a gyerekek tovább
      tudják vinni a sváb hagyományokat.<br /><br /><br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/07/1654375422040.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/07/1654375422069.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/07/1654375422096.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u
        ><h3>
          Közösségi fórum a projekt és a megvalósult programok értékeléséről, az
          esetleges folytatásokról
        </h3></u
      ><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2022. június 3-án Dunaszentmiklós
      Községházában nyolcadik alkalommal rendeztük meg a „Közösségi fórum a
      projekt és a megvalósult programok értékeléséről, az esetleges
      folytatásokról” kapcsolatos nyilvános programot, melyben a település
      lakosait tájékoztattam a Dunaszentmiklós Cselekvési Tervében az eddig
      megvalósult valamint a még megvalósulásra váró programokról. Néhány
      előhívott fényképet mutattam meg a jelen lévőknek az eddig megvalósult
      programokból. Öröm volt a visszatekintés, mosolyt csalt az emberek arcára.
      A rendezvényen 20 fő volt jelen.<br /><br />
      Keil Richárd képviselőtestületi tag is részt vett ezen alkalmon, aki
      köszöntötte a jelen lévőket és elmondta tapasztalatit az eddig
      községünkben megvalósult programokról. Nagy dicséretet kapott a
      Mesedélután sorozat. Elmondása szerint községünk mindig is nagy hangsúlyt
      fektetett a hagyományok ápolására, fenntartására. A Mesedélutánok pedig
      nagyon változatos témában foglalták össze a mai gyermekek számára a
      betelepített svábok múltját. A Mesedélutánon résztvevők megismerkedhettek
      jó néhány mondókával, dallal, körjátékkal, tánclépéssel, imádsággal és a
      Tájházban megbúvó múltbéli élettel. A jelen lévők egyet értettek a
      képviselő úr szavaival. Szívesen folyatnánk a Mesedélután foglalkozásokat
      a jövőben is megcélozva a jelen gyermekgenerációt. Továbbá megjegyezték,
      hogy nagy lehetőség volt a TOP-5.3.1-16-KO1- 2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatának köszönhetően a
      Weinrebe Dunaszentmiklós Boregyesület megalakulása. A helyi kis
      borosgazdáknak lehetőségük nyílt megismertetni, megkóstoltatni a saját
      maguk által megtermelt boraikat különböző rendezvényeken. Nagy egyetértés
      volta abban, hogy annakidején a község lakosai által összeállított
      cselekvési tervbe bevett programok mindegyike határozottan eleget tett a
      kohézió erősítésének. Alkalmanként új barátságok születtek gyerekek és
      családok körében is.<br /><br />
      Mondanivalójában gazdag és jó hangulatú találkozó, program volt!<br /><br /><br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/07/1654279243335.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/07/1654279243361.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/07/1654279243386.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Kerékpártúra</h3></u><br /><br />
      Tata Város Önkormányzata a 290/2017. (IX.11.)Tata Kt. határozata alapján a
      Terület és Településfejlesztési Operatív Program keretében pályázatot
      nyújtott be „Helyi identitás és kohézió erősítése” Tata és környéke
      borvidékén” címmel konzorciumban a Baj, Szomód, Neszmély, Dunaalmás és
      Dunaszentmiklós településsel. A projekt célja, hogy a konzorcium területén
      élők közösségi identitása – mint Tata és környéke borvidékhez tartozó
      települések lakosainak – kialakuljon és erősödjön, segítségül hívva ehhez
      a közösségfejlesztés különböző eszközeit, a közösségi részvételre épülő
      tervezési gyakorlatokat, közösségfejlesztő programokat, kiegészülve
      bűnmegelőzési, közbiztonsági és közlekedésbiztonsági programokkal.
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzat. 2022. május 13-án első alkalommal
      került megrendezésre a Kerékpártúra rendezvény. A Kerékpártúra a Szomódi
      Íriszkert Általános Iskolától indult s a következő túraútvonalakat
      érintette: Csengervölgy (szomódi borút), Öreghegy (dunaszentmiklósi
      borút), Dunaszentmiklós – Ströcker Vendéglő. Túravezető Kemenczkyné
      Hartmann Petra pedagógus, Dunaszentmiklós közösségfejlesztője volt. A
      túrán 31 fő vett részt a településről valamint a szomszédos Szomód
      konzorciumi település iskolás tanulói közül. A résztvevőket a
      kerékpártúrára felkészítettem, elméleti oktatást tartottam a helyes
      kerékpáros közlekedésről. A túra alatt a résztvevők egyszerre mozogtak, ez
      jó alkalom volt arra, hogy megismerjük tágabb környezetünket. A
      Kerékpártúra ebben az évben tartalmas látnivalóval gazdagította a falu
      lakóit és a túrán résztvevőket. Jó hangulatú túrát tudhatunk magunk
      mögött. A program végén a Ströcker Vendéglőben megpihentünk és minden
      résztvevő egy fagyival és egy üdítővel olthatta szomját. A helyi lakosok
      maguk fogalmazták meg, hogy szeretnék, ha a jövőben hagyományt öltene a
      Kerékpártúra.<br /><br /><br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/05/1652671855288.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/05/1652671855265.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/05/1652671855240.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Mesedélután - 2022.01.21.</h3></u><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2022. január 21-én a Szomódi
      Íriszkert Általános Iskolában tizedik alkalommal rendeztük meg a
      Mesedélután nevű programot. A rendezvényre a meghívót elkészítettem. A
      helyszínváltoztatás célja a tánccsoportba való toborzás volt.
      Dunaszentmiklós és Szomód település tanulói vettek részt a rendezvényen,
      ahol a 7-8 éves korosztályt szólítottuk meg. Kolléganőmmel egy-egy
      településünkre jellemző táncot mutattunk be és tanítottunk is be a
      gyerekeknek, bízva abban, hogy a jövőben többen képviseltetik magukat a
      tánccsoportban. Ezzel eleget tettünk a két konzorciumi település kohézió
      erősítésének is. A rendezvényen 18 fő vett részt. Dunaszentmiklós részéről
      a Schwung nevű táncot, míg Szomód részéről a Lahmkraum polka táncot
      mutattuk be és tanítottuk is meg gyermeki koreográfiában.<br />
      A jelenlévők jól érezték magukat. Az utókor számára a tizedik alkalommal
      megrendezésre kerülő Mesedélutánnak köszönhetően a gyerekek betekintést
      nyerhettek őseink tánckultúrájába.<br /><br /><br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/01/1643212720293.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/01/1643212720314 (1).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2022/01/1643212720334.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u
        ><h3>
          Fórum: Cselekvési terv felülvizsgálata a közösség aktiválásával
        </h3></u
      ><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2021. október 14- én a Schneider
      Gábor Borászatnál hetedik alkalommal rendeztük meg a Fórum: Cselekvési
      terv felülvizsgálata a közösség aktiválásával, melyben a település
      lakosainak szóban bemutattam Dunaszentmiklós Cselekvési Tervében az eddig
      megvalósult és a megvalósulásra váró programokat. Egy kellemes beszélgetés
      mellett az eddig megvalósult programokról összegyűjtöttük a pozitívumokat,
      negatívumokat, előnyöket és hátrányokat. Az eredmények: továbbra is a
      Mesedélután áll az „első” helyen: pozitívum: nagy közösségépítő szereppel
      bír és a fiatal családok egymással való megismertetését is elősegíti.
      Előnye: Az összegyűjtött sváb mondókák, dalok szövege, dallama fennmarad
      az utókor számára valamint gazdagodik a gyermeke szókincse magyarul,
      németül és svábul is. Negatívum, hátrány: semmi. Weinrebe Dunaszentmiklós
      Boregyesület megalakulása: pozitívumok: kis borosgazdákat összefogja,
      átöleli, egy egységként kezeli. Már több vendéggel sikerült boraikat
      megkóstoltatni a kis borosgazdáknak. Előnye: Kis borosgazdák megalakultak
      Weinrebe Dunaszentmiklós Boregyesület néven. A kétnapos borospince
      látogatás alkalmával még több vendéget ki tudnak szolgálni. Negatívum,
      hátrány: semmi. Horgászverseny: pozitívum: közösségépítő szereppel bírt,
      sikerélményhez juttatta az utánpótlást, a gyerekeket. Előnye: A
      közösségből egyszerre több ember tudott részt venni a programon.
      Negatívum, hátrány: semmi. Szemétszedés: Előnye: egy lépéssel közelebb a
      tiszta környezethez. Előnye: községünk környezete tisztább lett.
      Negatívum, hátrány: semmi. A rendezvényen 13 fő volt jelen. A
      helyszínváltoztatást indokolta, hogy Schneider Gábor pincészetében
      közvetlenül a hordóból meglehetett kóstolni az „új bort”, murcit.<br />
      A nap programja:<br />
      - Schneider Gábor Borászatnál bemutattam Dunaszentmiklós Cselekvési
      Tervében az eddig megvalósult és a megvalósulásra váró programokat.<br />
      - Zárásként: Betekintést nyerhettünk Schneider Gábor Borászatának életébe:
      ahol láthattuk a szőlő préselésének technikáját, valamint a présházban egy
      pohár murcival koccinthattunk.<br />
      Mondanivalójában gazdag és jó hangulatú találkozó, program volt!<br /><br /><br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/11/1634243313395.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/11/1634243313380.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/11/1634243313367.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Mesedélután - 2021.10.08.</h3></u><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2021. októberber 7.-én kilencedik
      alkalommal rendeztük meg a Mesedélután nevű programot.<br />
      „Svábokról mesél” programról röviden:<br />
      Ráhangoló mozgásos körjátékkal indult a foglalkozás. Majd képkártyák
      segítségével történt a heterogén csoportok kialakítása. Egy feladatlap
      segítségével átbeszélték, hogy „Kik vagyunk mi? Mik azok a
      jellegzetességek, amikről fel lehet minket ismerni? Egyáltalán vannak- e
      olyan jellegzetességek, amik egy egyénre, sőt , egy népcsoportra
      jellemzőek lehetnek?”<br />
      A foglalkozás során ezeket a kérdéseket járták körbe, s ezen gondolatok
      mentén ismerkedtek meg a svábok jellegzetességeivel a kiállításban
      megjelenő tárgyakon, problémákon keresztül.<br />
      A vallási hovatartozás megerősítése, a betelepítéshez használt hajó
      minimakettjének megtekintése, a meglévő ismeretek bővítése mind sikeressé
      tette a kilencedik Mesedélutánt.<br />
      Az utókor nemzedéke ismételten betekintést nyerhetett elődeink életébe. A
      TOP-5.3.1-16- KO1-2017-00002 Helyi identitás és kohézió erősítése Tata és
      környéke borvidékén pályázat ismét lehetővé tette, hogy a gyerekek tovább
      tudják vinni a sváb hagyományokat.<br /><br /><br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/10/20211007_kepek (1).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/10/20211007_kepek (2).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/10/20211007_kepek (3).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Szemétszedés</h3></u><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2021. október 2.-án
      Dunaszentmiklóson első alkalommal rendeztük meg a Szemétszedés nevű
      programot. A programon 20 fő vett részt.<br />
      A szemétszedés sikeres volt. 25 zsák szemetet sikerült összegyűjtenünk.
      Örömömre szolgált, hogy a gyerekek is képviseltették magukat a programon.
      A pályázatnak és a szülői magatartásnak köszönhetően a program elérte
      célját, a környezeti nevelés érdekében sikerült közösen tenni
      lakókörnyezetünk tisztaságáért.<br />
      A falu teljes területén kisebb csoportokban gyűjtöttük a szemetet. Petőfi
      Sándor utca, Ady Endre utca és tó környéke, Neszmélyi utca, Öreghegy,
      kilátó környékét sikerült megtisztítani.<br />
      A szemétszedést követően Dunaszentmiklós Községházában szendviccsel,
      süteménnyel és üdítővel vendégeltük meg a résztvevőket.<br />
      A TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és kohézió erősítése Tata és
      környéke borvidékén pályázat ismét lehetővé tette, hogy Dunaszentmiklós
      községért közösen tegyünk.<br /><br /><br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/10/szemetszedes (2).jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/10/szemetszedes (1).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/10/szemetszedes (2).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Mesedélután - 2021.09.08.</h3></u><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2021. szeptember 8.-án
      Dunaszentmiklóson nyolcadik alkalommal rendeztük meg a Mesedélután nevű
      programot. A programon 23 fő vett részt.<br />
      Dunaszentmiklósi Gyermektánccsoportól röviden: 2002-ben alakult a csoport
      a nagyobbak utánpótlásaként. Szintén Wenczl József koreográfiáit
      táncolják. Viseletükben ők is a helyi hagyományokat követik, a hétköznapi
      népviseletet hordják. A lányokon fehér blúz, piros „Woschkhiel” és fehér
      kötény van, a fiúkon fekete nadrág, fehér ing.<br />
      „Ismerd meg a magyarországi németek tánckultúráját!” nevet viselő
      meseélután célja a toborzás volt. A vezető új tagokkal szeretné bővíteni a
      gyermektánccsoportot, mivel az idei évtől több gyermek is a felnőtt
      tánccsoportban folyatja a táncos múltját, a hagyományok ápolását. A
      pályázatnak köszönhetően az új tagoknak fellépő szoknyát tudunk
      varrattatni. Az első közös táncórán a gyermekek játékosan (fogó játék,
      körjátékok) ismerkedtek egymással, majd zenére táncolni kezdtek.<br />
      A nyolcadik Mesedélután igen sikeres volt, hiszen 7 új gyermekkel bővült a
      Gyermektánccsoport.<br />
      Az utókor nemzedéke ismételten betekintést nyerhetett elődeink életébe. A
      TOP-5.3.1-16- KO1-2017-00002 Helyi identitás és kohézió erősítése Tata és
      környéke borvidékén pályázat ismét lehetővé tette, hogy a gyerekek tovább
      tudják vinni a sváb hagyományokat.<br /><br /><br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/10/mesedélután 8 (1).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/10/mesedélután 8 (2).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/10/mesedélután 8 (3).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u
        ><h3>
          Fórum: A Nyitott Borospincék programmal kapcsolatos nyilvános fórum a
          részvétléről
        </h3></u
      ><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2021. augusztus 6-án Dunaszentmiklós
      Községházában hatodik alkalommal rendeztük meg a Fórum: A Nyitott
      Borospincék programmal kapcsolatos nyilvános fórum a részvétléről
      programot, melyben a település lakosait tájékoztattam a Dunaszentmiklós
      Cselekvési Tervében az eddig megvalósult és a járvány helyzet végett
      elmaradt valamint a még megvalósulásra váró programokról. A két napos
      pincelátogatással kapcsolatban SWOT analízis módszerével összegyűjtöttük
      az erősségeket, gyengeségeket, lehetőségeket és veszélyeket. A
      rendezvényen 16 fő volt jelen. Mondanivalójában gazdag és jó hangulatú
      találkozó, program volt!<br /><br /><br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/08/20210806 (1).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/08/20210806 (2).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/08/20210806 (3).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Mesedélután - 2021.06.08.</h3></u><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2021. június 8.-án Szomódon hetedik
      alkalommal rendeztük meg a Mesedélután nevű programot.<br /><br />
      A helyszín megváltoztatása kedvező hatással volt a Szomód-Dunaszentmiklósi
      kapcsolatok ápolására, a gyermekeknél a kötődések kialakítására,
      barátkozásra, és nagyobb körben tudtuk megszervezni a programot.<br /><br />
      A Kuny Domokos Nemzetiségi Múzeum alkalmazottja, Nagy Dorina tartott
      „Svábokról mesél” című előadást, aminek a témája következő volt:<br />
      Kik vagyunk mi? Mik azok a jellegzetességek, amikről fel lehet minket
      ismerni? Egyáltalán vannak-e olyan jellegzetességek, amik egy egyénre,
      sőt, egy népcsoportra jellemzőek lehetnek? A foglalkozás során ezeket a
      kérdéseket jártuk körbe, s ezen gondolatok mentén ismerkedtünk meg a
      svábok jellegzetességeivel.<br /><br />
      A programon 25 gyermek vett részt, akik Szomódról és Dunaszentmiklósról
      vegyesen érkeztek.<br /><br />
      Az utókor nemzedéke ismételten betekintést nyerhetett elődeink életébe. A
      TOP-5.3.1-16-KO1- 2017-00002 Helyi identitás és kohézió erősítése Tata és
      környéke borvidékén pályázat ismét lehetővé tette, hogy a gyerekek tovább
      tudják vinni a sváb hagyományokat.<br /><br /><br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/06/20210608 (1).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/06/20210608 (2).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/06/20210608 (3).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Mesedélután - 2021.03.01.</h3></u><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2021. március 1.-jén
      Dunaszentmiklóson hatodik alkalommal rendeztük meg a Mesedélután nevű
      programot az online térben. A hatodik Mesedélután témája: Krumplipogácsa /
      Krumpelpogatschel. Sváb életképekből a Krumplipogácsa / Krumpelpogatschel
      nevű videót kellett megnézniük a jelentkezőknek, majd egy ehhez kapcsolódó
      feladatlapot kellett kitölteniük és visszaküldeniük a meghívóban
      feltüntetett e-mail címre. A videóban megismerkedhettek a nézők a
      krumplinyomó használatával, rá jellemző tulajdonságokkal, majd a
      krumplipogácsa elkészítésének menetével is.<br />
      A krumplinyomó egy keményfából készített négylábú eszköz. Kézzel faragott,
      kifelé álló négy becsapott láb tartja a vastag, hasáb alakú testet. Az
      eszköz közepén egy henger alakú nyílás van. Ebbe csúszik bele egy fa
      dugattyú, amit egy tengelyen, nyéllel lehet mozgatni. A henger alakú
      nyílás aljára egy kilyuggatott vasbádog lemezt erősítettek. A
      krumplinyomót egyebek mellett sváb krumplis tésztafélék (pl.:
      krumplistészta, krumplispogácsa stb.) készítésénél is használták. A
      krumplinyomónak ezt a fajtáját körülbelül az 1940-es évek végéig
      használták. A sváb takarékoskodó népség, leginkább azokból az
      alapanyagokból készítettek ételt, amit ők maguk termeltek. Így a
      leggyakrabban használt hozzávalóik a tej, liszt, krumpli, szalonna,
      káposzta és a paszuly.<br />
      A krumplispogácsa elkészítéséhez meg kell főznünk héjában a krumplikat,
      majd miután megfőtt, törtkrumplit készítünk. Ehhez teszünk tojást és sót.
      Majd az egészhez lisztet adagolunk, úgy, hogy a tészta kinyújtható állagú
      legyen. Ezután kinyújtjuk, és kiszaggatjuk. Már mehet is forró zsírba,
      szép barnára sütjük. „ Hetti és Náni elkészíti az ínycsiklandó
      krumplipogácsákat, amelyből Rézinek is küldenek, hiszen nagyon jó
      tojásokat adott. Miközben Náni átviszi szomszédjuknak a pogácsákat,
      Hettihez megérkezik udvarlója, Hansi. Kiderül, hogy Hettinek születésnapja
      van, és ez alkalomból Hansi egy általa faragott sulykolót ajándékoz
      neki.”<br />
      Feladatlap tartalma: Válaszd ki az alábbi alapanygok közül a
      krumplipogácsához szükséges hozzávalókat! Nevezd is meg őket! Milyen
      tárgyakat ismersz fel a háttérben? Válassz ki legalább kettőt, amit
      megnevezel és írd le mire használhatták!<br />
      12 fő vett részt az online térben megrendezésre került hatodik
      Mesedélutánon.<br />
      A tatai Német Nemzetiségi Múzeum segítségünkre volt a célunk
      megvalósításában, abban, hogy a „Sváb életképek” sorozatuk a német
      nemzetiségi kultúra egy-egy szeletét mutatta be korhű ruhákon, múzeumban
      gyűjtött tárgyakon és szokásokon keresztül. Így az utókor betekintést
      nyerhetett elődeink életébe. A TOP-5.3.1-16-KO1-2017-00002 Helyi identitás
      és kohézió erősítése Tata és környéke borvidékén pályázat ismét lehetővé
      tette, hogy a gyerekek tovább tudják vinni a sváb hagyományokat.<br /><br /><br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/06/20210302_pisak aron.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/06/20210302_schmidt roland.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2021/06/20210302_schmidt szofia.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u
        ><h3>
          Fórum: Cselekvési terv felülvizsgálata a közösség aktiválásával
        </h3></u
      ><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2020. október 2-án a Kősziklás
      Borászatnál ötödik alkalommal rendeztük meg a Fórum: Cselekvési terv
      felülvizsgálata a közösség aktiválásával, melyben a település lakosainak
      szóban bemutattuk Dunaszentmiklós Cselekvési Tervében az eddig megvalósult
      és a megvalósulásra váró programokat. Az eddig megvalósult programokról
      összegyűjtöttük a pozitívumokat, negatívumokat, előnyöket és hátrányokat.
      Az eredmények: Mesedélután: pozitívum: Közösségépítő, Fiatal családok
      egymással való megismertetése. Előnye: Az összegyűjtött sváb mondókák,
      dalok szövege, dallama fennmarad az utókor számára. Mesefigurák
      megismertetése. Hartmann Károlyné (Edit néni) beöltözött Piroskának.
      Negatívum, hátrány: semmi. Weinrebe Dunaszentmiklós Boregyesület
      megalakulása: pozitívumok: Kis borosgazdákat összefogja, átöleli, egy
      egységként kezeli. Előnye: Kis borosgazdák megalakultak Weinrebe
      Dunaszentmiklós Boregyesület néven. Negatívum, hátrány: semmi. Wanderung
      im Herbst/Őszi túra: pozitívum: Közösség építő, Megismerik a környező
      hegyeket, természet értékeit. Előnye: A közösségből egyszerre sok ember
      tudott részt venni a programon, ahol jót tudtunk beszélgetni. Negatívum,
      hátrány: semmi. Sváb Gasztró Nap: Közösség építő, Hagyományőrző. Előnye:
      Fánkkészítés elsajátítása, Kolbásztöltés után a zenés programok mellett
      egy fantasztikus hangulatban lehetett közösen beszélgetni, mulatni.
      Negatívum, hátrány: semmi. A rendezvényen 11 fő volt jelen. A
      helyszínváltoztatást indokolta az országban jelen lévő járványügyi
      helyzet. Nemes János Szomód község Közösségfejlesztőjével közösen
      szerveztük meg a napot, mivel így kívántunk eleget tenni annak, hogy a két
      település között/ Dunaszentmiklós és Szomód között a helyi identitás és
      kohézió erősödjön!<br /><br />

      A nap programja:<br />
      Szomódról a Művelődési Ház elől indult a DOTTÓ vonat, ami felhozott
      bennünket Szomódiakat és engem: Kemenczkyné Hartmann Petrát,
      Dunaszentmiklós Közösségfejlesztőjét Dunaszentmiklósra.<br />
      Dunaszentmiklóson tettünk egy kört a Dottó vonattal.<br />
      A Kősziklás Borászatnál találkozott egymással a két település. Ahol Nemes
      János köszöntötte a jelen lévőket, majd Kemenczkyné Hartmann Petra
      elmesélte Dunaszentmiklós múltját, jelenét, s Barcsa Botond beszélt a
      Kősziklás Borászat keletkezéséről és bemutatta boraikat. Több fajta bort
      kóstolhattunk és sajtos stanglit ropogtathattunk. A települések lakói jót
      beszélgettek, a Szomódi Dalkör énekkel szórakoztatta a közönséget.<br />
      Zárásként: Betekintést nyerhettünk a Kősziklás Borászat életébe: ahol
      láthattuk a szőlő préselésének technikáját, valamint a Fröccsteraszon egy
      pohár Pinot Noir Rozéval koccinthattunk.<br /><br />
      Mondanivalójában gazdag és jó hangulatú találkozó, program volt!<br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/10/20201002_forum 1..jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/10/20201002_forum 2..jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/10/20201002_forum 3..jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/10/20201002_forum 4..jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>
      <u><h3>Mesedélután</h3></u><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2020. október 27-én
      Dunaszentmiklóson a Ströcker Vendéglőben ötödik alkalommal rendeztük meg a
      Mesedélután nevű programot. A találkozón 30 fő volt jelen. Nagy Dorka a
      Német Nemzetiségi Múzeum drámapedagógusa tartott drámapedagógiai
      foglakozást a gyerekeknek.<br /><br />
      A Mesedélután témái a következők voltak:<br />
      HEIMAT? HAZA?<br /><br />
      A foglalkozás során beleképzeljük magunkat a németek helyzetébe, oly
      módon, hogy milyen érzésekkel hagyhatták el országukat egy jobb jövő
      reményében, milyen nehézségekkel kellett szembenézniük útjuk során,
      illetve milyen körülmények várták itt őket. A gyerekek megépíthetik saját
      házaikat, a benépesítésre váró környék alapanyagaiból és saját gazdaságot
      indíthatnak be.<br /><br />
      Mein Liebes Tagebuch: Naplóbejegyzés készítése<br />
      Letelepedési menetlevél készítése:<br /><br />
      A telepes kötelező magának szervezni utazását a lakhelyétől Bécsig, ezután
      folytatja útját Ulmi kikötővárosába, ahol várakozás után megkezdi utazását
      a Dunán, állami hatóságok vagy a magánföldesurak instrukciói szerint. Az
      alábbi adatokat töltse ki a hajóra való felszállás előtt: Betelepülő/
      betelepülők neve: … Magukkal hozott vagyon:….. 200Ft.<br /><br />
      Mesterségek és szerszámaik:<br />
      kádár: donga, csínvágó, gyalu;<br />
      szíjgyártó: szíj, lószerszám, ütőfej, sablonok;<br />
      asztalos: gyalu;<br />
      szőlész-borász: demizson, lopótök, kereplő<br /><br />
      A pályázatnak köszönhetően sikerült a dunaszentmiklósi svábok bejövetelét
      felidézni és a nyelvi kultúrát tovább öregbíteni az utókor számára.<br />
      A jelenlévők jól érezték magukat, gyarapodott a gyermekek szókincse sváb,
      német és magyar nyelven.
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/10/20201027 2..jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/10/20201027.jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/10/received_269177554476376 másolata.jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Mesedélután - 2020. Augusztus 26</h3></u><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2020. augusztus 26-án
      Dunaszentmiklós Könyvtárában negyedik alkalommal rendeztük meg a
      Mesedélután nevű programot. A találkozón 20 fő volt jelen. Nemes Szilvia a
      Német Nemzetiségi Tánccsoport vezetője körjátékot, német táncokat tanított
      és énekelt a gyerekeknek sváb- német és magyar nyelven.<br />
      A mesedélután témái a következők voltak:<br />
      ének és körjáték: Liebe Schwester tanz mit mir - Nővérkém táncolj velem<br />
      német táncok :Bauernmadl, Fröhlicher Kreis, Gickerl Polka, Judenpolka .<br />
      Továbbá a táncosok Écsi Gyöngyi interaktív előadásán vettek részt.<br />
      Dunaszentmiklóson immáron hagyománnyá vált tánctáborhoz csatlakozott a
      Helyi identitás és kohézió erősítése Tata és környéke borvidékén pályázat.
      A pályázatnak köszönhetően lehetőség nyílt egy nagyobb létszámú
      táboroztatásra. Így nem csak a gyermektánccsoport tagjai, hanem a faluban
      élő gyermekek közül bárki részt vehetett az eseményen, ahol ki lehetet
      próbálni az új tánclépéseket, elsajátítani egy újabb sváb körjátékot,
      melynek nyelvezetével sikerült a dunaszentmiklósi sváb nyelvi kultúrát
      tovább öregbíteni az utókor számára.<br />
      A táncos hangulatú mesedélutánon a gyerekek mulatságban bővelkedő
      hangulatban búcsúztatták a nyarat. A jelenlévők jól érezték magukat,
      gyarapodott a gyermekek szókincse sváb, német és magyar nyelven. Az utókor
      számára a negyedik alkalommal megrendezésre kerülő Mesedélutánnak
      köszönhetően bővült a régi sváb hagyományok gyűjteménye.<br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/08/mesedeletan4_20200826 (1).jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/08/mesedeletan4_20200826 (17).jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/08/mesedeletan4_20200826 (23).jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/08/mesedeletan4_20200826 (17).jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/08/mesedeletan4_20200826 (14).jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/08/mesedeletan4_20200826 (15).jpeg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u
        ><h3>
          Dunaszentmiklósi Borbarátok Egyesület első nyilvános egyeztető fóruma
        </h3></u
      ><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2020. július 3-án Dunaszentmiklós
      Községházában negyedik alkalommal rendeztük meg a Dunaszentmiklósi
      Borbarátok Egyesület első, nyilvános ülését, melyben a település
      lakosainak bemutattuk a Weinrebe Dunaszentmiklós Boregyesület céljait. A
      rendezvényen 21 fő volt jelen.<br /><br />
      A Dunaszentmiklósi Borbarátok Egyesület – Weinrebe Dunaszentmiklós
      Boregyeesület első, nyilvános ülésének témái a következők voltak:<br />
      - Kemenczkyné Hartmann Petra Dunaszentmiklós Közösségfejlesztője
      köszöntötte a jelenlévőket és ismertette az est programját. Ezt követően
      kézfeltétellel a jelenlevők megbízták a közösségfejlesztőt, hogy járjon el
      a CST módosításának az ügyében és adja be az irányító hatóság felé a
      változtatási kérelmet.<br />
      - Továbbá a Weinrebe Dunaszentmiklós Boregyesület elnökségi tagjai közül
      Nemes Szilvia mutatta be a boregyesület megalakulásának folyamatát,
      megalakulását és a Weinreb Dunaszentmiklós Boregyesületre váró feladatokat
      az elkövetkezendő 2021-es és 2022-es évre vonatkozóan.<br />
      Weinrebe Dunaszentmiklós Boregyesület megalakulásának folyamata:<br />
      2019:<br />
      • Első egyeztető fórum a közösség bevonásával a Dunaszentmiklósi
      Borbarátok Egyesület alapításának kezdeményezéséről<br />
      • A Dunaszentmiklósi Borbarátok Egyesület alapításának kezdeményezése
      2020:<br />
      • Egyeztető fórum a Dunaszentmiklósi Borbarátok Egyesület alapításának
      folyamatairól.<br />
      • Dunaszentmiklósi Borbarátok Egyesület – Weinrebe Dunaszentmiklós
      Boregyesület megalapítása Weinrebe Dunaszentmiklós Boregyesület
      megalakulása:<br />
      2020:<br />
      • Az alapszabályzat rövid ismertetése.<br />
      Weinrebe Dunaszentmiklósi Boregyesületre váró feladatok:<br />
      2021:<br />
      • Fórum: A Nyitott Borospincék programmal kapcsolatos nyilvános fórum a
      részvétléről Részvételi fórumok elindítása, működtetése, meglévők
      fejlesztése<br />
      • Dunaszentmiklósi Borverseny Programok, folyamatok megvalósítása<br />
      • Fórum: Cselekvési terv felülvizsgálata a közösség aktiválásával
      Részvételi fórumok elindítása, működtetése, meglévők fejlesztése:<br />
      2022:<br />
      • Közösségi fórum a projekt és a megvalósult programok értékeléséről, az
      esetleges folytatásokról<br />
      • Nyitott pincék = Dunaszentmiklósi Borbarátok Egyesülete megalakulását
      követően a borbarátok szervezésében és lebonyolításában<br />
      Mondanivalójában gazdag és jó hangulatú est volt! A Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatnak köszönhetően
      megalakult a Weinrebe Dunaszentmiklós Boregyesület, a lakosságnak
      bemutatták céljaikat, s a Cselekvési Tervnek megfelelően elkezdik a rájuk
      váró programok megvalósítását!
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/07/20200703_weinrebedunszentmiklosboregyesuletforum4 (2).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/07/20200703_weinrebedunszentmiklosboregyesuletforum4 (3).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/07/20200703_weinrebedunszentmiklosboregyesuletforum4 (4).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/07/20200703_weinrebedunaszentmiklosboregyesuletforum4 (5).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Dunaszentmiklósi Borbarátok Egyesület megalapítása</h3></u
      ><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2020. június 18-án Dunaszentmiklós
      Községházában harmadik alkalommal rendeztük meg az Egyeztető fórum a
      Dunaszentmiklósi Borbarátok Egyesület megalapítása nevű programot. A
      rendezvényen 14 fő volt jelen.<br />
      A Dunaszentmiklósi Borbarátok Egyesület megalapítása rendezvény témái a
      következők voltak:<br />
      - Kemenczkyné Hartmann Petra Dunaszentmiklós Közösségfejlesztője
      köszöntötte a borosgazdákat, majd előterjesztette az egyesületre váró
      programokat.<br />
      - Ströcker Zoltán, Weinrebe Dunaszentmiklós Boregyesület elnöke ismertette
      az alapszabályzatot, melyek a következő pontokból tevődtek össze:<br />
      I. Az egyesület adatai<br />
      II. Az egyesület célja, tevékenysége<br />
      III. Az egyesület működésére vonatkozó általános szabályok<br />
      IV. Tagdíj<br />
      V. A tagság<br />
      VI. A tagsági jogviszony keletkezése<br />
      VII. A tagsági jogviszony megszűnése<br />
      VIII. A tagok jogai<br />
      IX. A tagok kötelezettségei<br />
      X. Az egyesület szervei<br />
      XI. A közgyűlés<br />
      XII. Elnökség<br />
      XIII. Záró rendelkezések<br />
      Jó hangulatú este volt. A borosgazdák közösen örültek, hogy a borkultúra
      gondozása érdekében megalakult a Weinrebe Dunaszentmiklósi
      Boregyesület.<br />
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/06/20200618_weinrebedunaszentmiklosboregyesulet_3 (2).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/06/20200618_weinrebedunszetnmiklosboregyesulet_3 (11).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/06/20200618_weinrebedunszetnmiklosboregyesulet_3 (24).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/06/20200618_weinrebedunszetnmiklosboregyesulet_3 (23).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Mesedélután/ Rajzkiállítás/ Kiegészítő összefoglaló</h3></u
      ><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2020. május 20-án (Rajzpályázat
      leadási határidejét jelöli) és 24-én (Örömút időpontját jelöli)
      Dunaszentmiklóson harmadik alkalommal rendeztük meg a Mesedélután nevű
      programot. A Rajzpályázaton részt vett alkotásokat szándékunkban állt
      kiállítani Dunaszentmiklós Könyvtárában. A járvány helyzet ezt megengedte,
      lehetővé tette 2020. júniusában. Így, 2020. június 25-én Dunaszentmiklós
      Könyvtárában 17:00-19:00 óra között Kiállítást rendeztünk „Az én
      templomom” című Rajzpályázaton részt vett nyertes alkotásokból. A
      Kiállítást 16 fő látogatta meg. A Mesedélután teljes időtartalma alatt a
      létszámok alakulása: a Rajzpályázaton 7 fő vett részt, az Örömút járáson
      10 fő volt jelen és a Kiállítást 16 fő látogatta meg. Így összesen a
      Mesedélutánon 33 fő volt jelen.<br />
      A Kiállítást a jó hangulat jellemezte.<br />
      Célunk a pályázat révén is megszólítani a fiatalabb korosztályt a
      tekintetben, hogy minél többen, minél hosszabb ideig látogassák községünk
      Szent Miklós templomát. Úgy gondoljuk, hogy a TOP-5.3.1-16-KO1-2017-00002
      Helyi identitás és kohézió erősítése Tata és környéke borvidékén pályázat
      nagy segítségünkre sietett ebben!
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/06/20200625_mesedelutankialltas3 (1).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/06/20200625_mesedelutankialltas3 (2).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/06/20200625_mesedelutankialltas3 (3).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Mesedélután - 2020. május 20</h3></u><br /><br />
      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2020. május 20-án (Rajzpályázat
      leadási határidejét jelöli) és 24-én (Örömút időpontját jelöli)
      Dunaszentmiklóson harmadik alkalommal rendeztük meg a Mesedélután nevű
      programot, amit két részletben tartottunk meg a Korona vírus által
      kialakult helyzet végett. Rajzpályázatot hirdettünk „Az én templomom”
      címmel, valamint Örömút járást tartottunk a dunaszentmiklósi Szent Miklós
      templom udvarában. A Rajzpályázaton 7 fő, az Örömút járáson 10 fő volt
      jelen, tehát összesen 17 fő vett részt a harmadik Mesedélutánon. Hartmann
      Károlyné Edit néni online mesélt a gyerekeknek az Örömút 14 állomás
      történetéről német nyelven, magyar nyelven Kemenczkyné Hartmann Petra
      Dunaszentmiklós közösségfejlesztője mesélt. A projekt ideje alatt a helyi
      sváb mesék és szokások felelevenítése mellett az egyházi kapcsolódásra is
      hangsúlyt kívánunk fektetni. Értem ez alatt, hogy gyűjtőmunkát végzünk a
      helyi sváb imádságok összegyűjtésében, hogy az, az utókor számára
      fennmaradjon. <br />
      Célunk továbbá a pályázat révén is megszólítani a fiatalabb korosztályt a
      tekintetben, hogy minél többen, minél hosszabb ideig látogassák községünk
      Szent Miklós templomát. Úgy gondoljuk, hogy a TOP-5.3.1-16-KO1-2017-00002
      Helyi identitás és kohézió erősítése Tata és környéke borvidékén pályázat
      nagy segítségünkre sietett ebben!
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/05/img (1).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/05/img (2).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/05/img (3).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/05/img (4).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/05/img (5).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/05/img (6).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/05/img (7).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/05/img (8).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2020/05/img (9).jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Mesedélután - 2020. február 20</h3></u><br /><br />

      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata.
      <br />
      2020. február 20-án Dunaszentmiklós Könyvtárában második alkalommal
      rendeztük meg a Mesedélután nevű programot. A találkozón 34 fő volt jelen.
      Hartmann Károlyné Edit néni mondókázott, kőrjátékozott, énekelt a
      gyerekeknek sváb- német és magyar nyelven. <br />
      A mesedélután témái a következők voltak: ének és körjáték a színekről:
      Lied über die Farben - Grün, grün, grün sind alle meine Kleider – Minden
      ruhám zöld; To hockt ti oldi Weadahex in Reign und in Schnee – Itt ül a
      vén boszi esőben és hóban; Fuchs, du hast die Gans gestohlen –Róka,
      elloptad a libát! ; kézműves foglalkozás, ahol farsangi állarcokat
      színezhettek a gyerekek.<br />
      A résztvevő gyerekek megtanulták önállóan énekelni a „ Grün, grün, grün
      sind alle meine Kleider…”dalt, a színeket, foglalkozásokat is önállóan
      megnevezték svábul, németül és magyarul. <br />A farsangi hangulatú
      mesedélutánon a jelmezbe bújt gyerekek ételekben, italokban és mulatságban
      bővelkedő hangulatban búcsúztatták a telet. A jelenlévők jól érezték
      magukat, gyarapodott a gyermekek szókincse sváb, német és magyar nyelven.
      Az utókor számára a második alkalommal megrendezésre kerülő Mesedélutánnak
      köszönhetően bővült a régi sváb hagyományok gyűjteménye.

      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/1-2.jpg"
            alt="1"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/2-2.jpg"
            alt="2"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/3-2.jpg"
            alt="3"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/4-2.jpg"
            alt="4"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/5-2.jpg"
            alt="5"
            width="747"
            height="421"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/6-2.jpg"
            alt="6"
            width="747"
            height="421"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/7-2.jpg"
            alt="7"
            width="720"
            height="406"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/8-2.jpg"
            alt="8"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/9-1.jpg"
            alt="9"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/10-1.jpg"
            alt="10"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/11-1.jpg"
            alt="11"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/12-1.jpg"
            alt="12"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/13.jpg"
            alt="13"
            width="1381"
            height="1037"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/14.jpg"
            alt="14"
            width="1381"
            height="1037"
          />
        </div>
      </div>

      <u><h3>Dunaszentmiklósi Sváb Gasztró Nap</h3></u><br /><br />

      Konzorciumi tagként a TOP-5.3.1-16-KO1-2017-00002 Helyi identitás és
      kohézió erősítése Tata és környéke borvidékén pályázatban részesült
      Dunaszentmiklós Község Önkormányzata. 2020. február 8-án Dunaszentmiklós
      Községházában első alkalommal rendeztük meg a Dunaszentmiklósi Sváb
      Gasztró Napot, programot. A találkozón 88 fő volt jelen. Dunaszentmiklósi
      Sváb Gasztró Nap témája a sváb hagyományos ételek elkészítése, hagyományos
      húsfeldolgozás, fánk sütés voltak. A közösségi beszélgetések során a
      legtöbben egyértelműen az iránt fejezték ki aggályukat, hogy a gyerekek
      már nem ismerik, ezért nem is tudják tovább vinni a sváb hagyományokat,
      így fontosnak tartjuk, hogy amíg itt vannak közöttünk, akiktől tudunk
      tanulni, tegyük meg azt. Tíz csapat indult a kolbásztöltő fesztiválon,
      csapatonként 5 fővel. Feladatuk volt, hogy 10kg kolbászhúsból sütni való
      kolbászt készítsenek. A versenyben résztvevő csapatoknak egy darab 20
      cm-es kolbászt kellett leadni a zsűrizéshez. A zsűri értékelte a
      kolbászkészítés folyamatát, a nyers kolbász esztétikai megjelenését, a
      megsütött kolbász ízét, állagát, asztal dekorációt. A verseny fődíja a
      Wurstfest kupa volt. A Wurstfest – Kolbásztöltő Fesztivál egy időnként
      visszaköszönő program a faluban, azonban a TOP-5.3.1-16-KO1-2017-00002
      Helyi identitás és kohézió erősítése Tata és környéke borvidékén
      pályázatnak köszönhetően kiegészült egy családi, gyereknek szóló
      programmal is, a fánk készítéssel, sütéssel. Ströcker Ignáncné mutatta meg
      a hagyományos fánk készítés és sütés menetét. A gyerekek kipróbálták a
      kelesztést, fánk szaggatást és a nagyobbak a fánk díszítését is. A jó
      hangulatról a Die Laus Buben zenekar és a Fligende Zöpfe szomódi táncosok
      gondoskodtak. A családok, a részvevők egy újabb dunaszentmiklósi sváb
      hagyománnyal gazdagodtak, melyeket tovább öregbíthetnek az utókor számára.
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/1-1.jpg"
            alt="1"
            width="1992"
            height="1121"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/2-1.jpg"
            alt="2"
            width="918"
            height="1224"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/3-1.jpg"
            alt="3"
            width="1992"
            height="1121"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/4-1.jpg"
            alt="4"
            width="1224"
            height="918"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/5-1.jpg"
            alt="5"
            width="1992"
            height="1121"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/6-1.jpg"
            alt="6"
            width="1992"
            height="1121"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/7-1.jpg"
            alt="7"
            width="1120"
            height="1992"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/8-1.jpg"
            alt="8"
            width="1120"
            height="1992"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/9.jpg"
            alt="9"
            width="1120"
            height="1992"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/10.jpg"
            alt="10"
            width="1992"
            height="1121"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/11.jpg"
            alt="11"
            width="1992"
            height="1121"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/12.jpg"
            alt="12"
            width="1992"
            height="1121"
          />
        </div>
      </div>
      <u
        ><h3>
          Egyeztető fórum a Dunaszentmiklósi Borbarátok Egyesület alapításnak
          folyamatairól
        </h3></u
      ><br /><br />
      Dunaszentmiklóson az Egyeztető fórum a Dunaszentmiklósi Borbarátok
      Egyesület alapításnak folyamatairól nevű program 2020. január 24-én került
      megrendezésre a Dunaszentmiklósi Községházában. <br />A rendezvényen 38 fő
      volt jelen. A Weinrebe Dunaszentmiklósi Boregyesület tagjai röviden
      beszámoltak az egyesületben eddig történtekről, s lehetőséget
      biztosítottak arra, hogy a boregyesülethez a jelen lévők
      csatlakozhassanak. <br />Mikóczy István a Weinrebe Dunaszentmiklósi
      Boregyesület elnökségi tagja előadásában hallhattunk a Bibliai üzenetek a
      szőlőn és a boron keresztül témáról. Közreműködtek a Tatai Református
      Gimnázium énekkaros diákjai és a Heimatskreis Niklo dalkör . <br />A
      vendégek az előadás közben a Kősziklás Borászat borait kóstolhatták olíva
      olajban mártott kenyér falatok kíséretében. A találkozót a jó hangulat
      jellemezte. A kis és nagy boros- gazdák közösen örültek Dunaszentmiklós
      Község lakóival annak, hogy a borkultúra gondozása érdekében elindult
      Dunaszentmiklóson egy kezdeményezés, név szerint: Dunaszentmiklósi
      Borbarátok Egyesület alapításnak kezdeményezése, s hogy már az új nevet
      viselő egyesület: Weinrebe Dunaszentmiklósi Boregyesület alapítási
      folyamatainak szárnyai szépen kezdenek kibontakozni!

      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/1.png"
            alt="1"
            width="565"
            height="424"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/2.png"
            alt="2"
            width="560"
            height="425"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/3.png"
            alt="3"
            width="580"
            height="432"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/4.png"
            alt="4"
            width="581"
            height="434"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/5.png"
            alt="5"
            width="369"
            height="458"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/6.png"
            alt="6"
            width="550"
            height="409"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/7.png"
            alt="7"
            width="600"
            height="444"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/8.png"
            alt="8"
            width="593"
            height="442"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/9.png"
            alt="9"
            width="555"
            height="419"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/10.png"
            alt="10"
            width="552"
            height="410"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/11.png"
            alt="11"
            width="579"
            height="409"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/12.png"
            alt="12"
            width="579"
            height="425"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/13.png"
            alt="13"
            width="597"
            height="441"
          />
        </div>
      </div>

      <u
        ><h3>
          Dunaszentmiklósi Borbarátok Egyesület alapításnak kezdeményezése
        </h3></u
      ><br /><br />
      A TOP 5.3.1-16-KO1-217-00002 Helyi identitás és kohézió erősítése Tata és
      környéke borvidékén pályázat keretén belül Dunaszentmiklós Önkormányzata
      által Dunaszentmiklóson a Dunaszentmiklósi Borbarátok Egyesület
      alapításnak kezdeményezése nevű program 2019. november 7-én került
      megrendezésre a Dunaszentmiklósi Német Nemzetiségi Teremben.
      <br />A rendezvényen 24 fő kis és nagy borosgazda volt jelen. <br />Béger
      Ákos polgármester úr és Kemenczkyné Hartmann Petra közösségfejlesztő
      ismertették a Helyi Cselekvési Tervben leírtakat a Dunaszentmiklósi
      Borbarátok Egyesületre vonatkozóan. <br />A jelenlévők megválasztották az
      elnököt és az elnökségi tagokat. A találkozót a jó hangulat jellemezte.
      <br />A kis és nagy boros- gazdák közösen örültek a lehetőségnek, hogy a
      borkultúra gondozása érdekében elindult Dunaszentmiklóson a
      Dunaszentmiklósi Borbarátok Egyesület alapításnak kezdeményezése.

      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/b6.png"
            alt="b6"
            width="605"
            height="442"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/b5.png"
            alt="b5"
            width="601"
            height="445"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/b4.png"
            alt="b4"
            width="603"
            height="447"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/b3.png"
            alt="b3"
            width="605"
            height="448"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/b2.png"
            alt="b2"
            width="603"
            height="451"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/b1.png"
            alt="b1"
            width="607"
            height="458"
          />
        </div>
      </div>

      <u><h3>Őszi Túra- Wanderung im Herbst</h3></u><br /><br />
      A TOP 5.3.1-16-KO1-217-00002 Helyi identitás és kohézió erősítése Tata és
      környéke borvidékén pályázat keretén belül Dunaszentmiklós Önkormányzata
      által Dunaszentmiklóson az Őszi Túra/ Wanderung im Herbst nevű rendezvény
      2019. október 27.-én került megrendezésre.<br />
      A túra Dunaszentmiklós Községházától indult s a következő túraútvonalakat
      érintette: Dunaszentmiklós Sportpálya- Hármas tölgy- Bors-hegyi vadászház
      és sziklák, Sátványpuszta- Gerecsei öreg tölgy- Arborétum bejárata-
      Vadaspark- Dunaszentmiklós. <br />Túravezető ifj. Aradi Péter volt. A
      túrán 81 fő vett részt a településről, a szomszédos Szomód konzorciumi
      településről valamint a Tatai Református Gimnázium Erdei iskolás tanulói
      közül. <br />Jó hangulatú, látványban gazdag, tartalmas túrát tudhatunk
      magunk mögött. A helyi lakosok maguk fogalmazták meg, hogy szeretnék, ha a
      jövőben hagyományt öltene az Őszi Túra.

      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/t1.png"
            alt="t1"
            width="567"
            height="423"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/t3.png"
            alt="t3"
            width="533"
            height="398"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/t4.png"
            alt="t4"
            width="530"
            height="394"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/t5.png"
            alt="t5"
            width="573"
            height="428"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/t5.png"
            alt="t5"
            width="573"
            height="428"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/t7.png"
            alt="t7"
            width="446"
            height="333"
          />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <img
            class="scale-with-grid"
            src="../../../assets/dokumentumok/uploads/2019/11/t8.png"
            alt="t8"
            width="466"
            height="348"
          />
        </div>
      </div>
    </div>
  </app-accordion>

  <a
    class="competition-link px-4 py-3 mx-auto"
    href="http://dunaszentmiklos.hu/assets/extra/szennyviz/"
    target="_blank"
    >ÉSZAK- ÉS KÖZÉP-DUNÁNTÚLI SZENNYVÍZELVEZETÉSI ÉS -KEZELÉSI FEJLESZTÉS 7.
    (ÉKDU 7)</a
  >
</div>
